// ADL
import $ from 'jquery';
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import frm from '../formAux.js'
const { Liquid } = require('liquidjs');

var mode = 'adl';

var closeIcon = '';
var searchIcon = '';

var descriptor = {};
var tagData = descriptor;
var dashjs = window.dashjs;
var WaveSurfer = window.WaveSurver;
var hinst = null;
var jQuery = $;
var modeSelDrop = null;
var wsclicked = false;
var seekPlaying = null;
// ADLEND

// EXPORTSTART


/*
question
asnwer
instructions
true/false
*/
var video = $('#video')[0];
var audioObj = $('#audio')[0];
var txtSeparator = ': ';
var wavesurfer = null;
var playToCallback = null;
var declined = false;
var claimed = false;
var released = false;
var reviewMode = false;
var transcriptionMode = false;

let videoClick = false;
let videoClickTid = null;

var currentMode = null;
var currentSeg = null;
var waveMode = null;
var declineReason = '';


function px(v) { return v+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return !isarray(o) && o instanceof Object;}
function isnumber( o ){ return typeof(o) == 'number' && !isNaN(o);}
function isstring( o ){ return typeof(o) == 'string';}
function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }
function nullFunc() { return null; }
function cancelEvent(ev) { if( !ev )return false; ev.preventDefault(); ev.stopPropagation();}

function iarray( v, n )
{
	var ret = [];
	for( var i = 0 ; i < n ; i++ )
	ret.push( v instanceof Object ? clone(v) : v );
	return ret;
}

function bool( s )
{
	if( typeof(s) == 'boolean' ) return s;
	if( !defined(s) || s === null ) return false;
	if( typeof(s) == 'number' ) return s > 0;
	if( s.match(/^y/i) ) return true;
	return false;
}

function sbool( v )
{
	return ['No','Yes'][v];
}

var setHeightTid = null;

function paletteWheel( div, brightness )
{
	if( !brightness ) brightness = 1;
  	var steps = [[255,0,0],[0,255,0],[0,0,255],[255,0,0]];
    var colors = [];
    function interpolate(v)
    {
        v *= steps.length-1;
        var i = Math.floor(v);
        var r = v-i;
        var ir = 1-r;
        // console.log( 'v', v, 'i', i, 'r', r );
        return [steps[i][0]*ir+steps[i+1][0]*r,steps[i][1]*ir+steps[i+1][1]*r,steps[i][2]*ir+steps[i+1][2]*r];
    }
    for( var d = 0 ; d < div ; d++ )
    {
        var c = interpolate( d/div);
        var hc = '#' + c.map( v => Math.min(Math.floor(v*brightness),255).toString(16).padStart(2,'0')).join('');
        colors.push( hc );
    }
    return colors;
}

function tracks( domObj, videoObj, videoSource, tagData, reportObj )
{
	$('.main').show();

    // add video control panel
    tagData.startTimestamp = new Date().getTime();
    tagData.startUTCTime = new Date().toUTCString();
    var content = $('<div>');
    var modalHtml = $('<div class="modal fade" id="modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true"><div class="modal-dialog modal-dialog-centered" role="document"><div class="modal-content"><div class="modal-header"><h5 class="modal-title" id="modaltitle">Modal title</h5><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body" id="modalcontent"></div><div class="modal-footer"><button type="button" class="btn btn-pink" data-dismiss="modal">Close</button><button type="button" class="btn btn-primary" id="modalaction">Save changes</button></div></div></div></div>');
    content.append(modalHtml);
    // domObj.css({position:'relative'});
    var panel = $('<div>').prop('id','trackpanel').addClass('trackpanel centered text-center');
    var slider = $('<div>').prop('id', 'slider').addClass('trackslider');
    var sliderPos = $('<div>').prop('id', 'sliderpos').addClass('tracksliderpos');
    var vstart = $('<div>').prop('id', 'vstart').addClass('trackbutton').html('<i class="fa fa-fast-backward" aria-hidden="true"></i>');
    var vprev = $('<div>').prop('id', 'vprev').addClass('trackbutton').html('<i class="fa fa-step-backward" aria-hidden="true"></i>');
    var vplay = $('<div>').prop('id', 'vplay').addClass('trackbutton').html('<i class="fa fa-play" aria-hidden="true"></i>');
    var vpause = $('<div>').prop('id', 'vpause').addClass('trackbutton').html('<i class="fa fa-pause" aria-hidden="true"></i>');
    var vnext = $('<div>').prop('id', 'vnext').addClass('trackbutton').html('<i class="fa fa-step-forward" aria-hidden="true"></i>');
    var vend = $('<div>').prop('id', 'vend').addClass('trackbutton').html('<i class="fa fa-fast-forward" aria-hidden="true"></i>');

    var vspeed = $('<div>').addClass('trackright')
    var v05x = $('<div>').prop('id', 'v05x').addClass('trackrate v0').html('0.5X');
    var v1x = $('<div>').prop('id', 'v1x').addClass('trackrate v1').html('1X');
    var v2x = $('<div>').prop('id', 'v2x').addClass('trackrate v2').html('2X');
    var vpos = $('<div>').prop('id', 'vpos').addClass('trackleft').html('0:00.0');
    vspeed.append( v05x, v1x, v2x );

    var selectedTrack = null;
    var selectedRangeId = -1;
    var selectedRange = null;
	var allRanges = null;
    var mediaType = null;

    domObj.append(content);
    slider.append(sliderPos);
    panel.append(slider, vpos, vstart, vprev, vplay, vpause, vnext, vend, vspeed );
    panel.hide();
    content.append(panel);
    content.addClass('trackanotate');
    videoObj.addClass('trackvideo');
    video = videoObj[0];
    sliderPos.css({width: pc(0)});
    slider.click(function(e)
    {
        var pos = e.offsetX/slider.width()*video.duration;
        videoPos( pos );
        // console.log( pos, pos*video.duration );
    });
	// video.ontimeupdate = videoPosUpdate;
    vplay.click(videoPlay);
    vpause.click(videoPause);
    vstart.click(function(){videoPos(0)});
    vend.click(function(){videoPos(video.duration)});
    vnext.click(videoForward);
    vprev.click(videoRewind);
    v05x.click(function(){ videoRate(0.5)});
    v1x.click(function(){ videoRate(1)});
    v2x.click(function(){ videoRate(2)});
    var ruler = $('<div>').prop('id','trackruler').addClass('trackruler');
    var tcontrols = $('<div>').addClass('trackcontrol').html('');
    var cursor = $('<div>').prop('id','trackcursor').addClass('trackcursor');
    var tracks = $('<div>').addClass('tracklist');
    ruler.on('mousedown',rulerDn);
    ruler.on('mouseup',rulerUp);
    content.append(ruler,tcontrols,tracks, cursor);
    var isRecording = false;
    var recordingRanges = [];
    var czommIn = $('<div>').addClass('trackrulerzoommin').html('+').click(zoomIn);
    var czoomTxt = $('<div>').addClass('trackrulerzoomtxt').html('');
    var czoomOut = $('<div>').addClass('trackrulerzoomout').html('-').click(zoomOut);
	var newName = descriptor.addButton || 'Add New Track';
    var cadd = $('<div>').addClass('trackaddbutton').html(newName).click(addTrack);
    var crec = $('<div>').addClass('trackaddrecording').click(recording);
    endRecording();
    tcontrols.append(czommIn,czoomTxt,czoomOut,cadd, crec);
	if( transcriptionMode || descriptor.hierarchy ){
		crec.css({left:10})
		cadd.hide();
	}
    // video positioning functions

    var playTo = -1;
	var lastPosTime = null;
    function videoPosUpdate()
    {
        // console.log( 'videoPosUpdate', video.currentTime, video.duration )
        if( playTo != -1 && video.currentTime >= playTo ) return stopplayback();
        var pos = video.currentTime/video.duration;
		var now = Date.now();
		var dt =now-lastPosTime;
		if( dt > 1500 ) dt = 0;
        sliderPos.css( {width:pc(100*pos) });
        if( video.paused && playing ) videoPause();
        vpos.html(ftime(video.currentTime,0)+' / '+ftime(video.duration,0));
        posCursor(dt);
        if( isRecording )
        {
            recordingRanges.forEach( function(rangeId){
                var range = $('#'+rangeId)
                var r = range.prop('range');
                if( video.currentTime < r[0] ) return endRecording();
                r[1] = video.currentTime;
                updateRange( range, r );
            });
        }
		else if( playing && playTo == -1 && transcriptionMode && allRanges ) { // hightlight current range if playing
			var psec = video.currentTime;
			var s = null;
			for( var r of allRanges )
			{
				// console.log( psec, r.start, r.end )
				if( r.end < psec ) continue;
				if( r.start > psec+0.1 ) break;
				s = r;
				break;
			}
			if( s )
			{
				selectRange( $('#'+s.id) );
				reportSelect( s.id );
			}
			else
			{
				unselectAll();
				reportUnselect();
			}
		}
		lastPosTime = Date.now();
    }
	var lastTrackSel = null;

    function videoPos( pos )
    {
        if (pos > video.duration) return console.error('position is longer then full media duration')
        playTo = -1;
        console.log( 'videoPos', pos );
        video.currentTime = pos;
        // videoPosUpdate();
    }
    function videoPlay()
    {
        playing = true;
        video.play();
        vplay.hide();
        vpause.show();
    }
    function videoPause()
    {
        playing = false;
        video.pause();
        vplay.show();
        vpause.hide();
    }

	var fixTid = null;
	function videoPosSel()
	{
		var sel = null;
		var idx = 0;
		if( startSelect ) { sel = startSelect; idx = 0 }
		if( endSelect ) { sel = endSelect; idx = 1 }
		if( sel )
		{
			selectRange( $('#'+sel.id))
			var r = selectedRange.prop('range');
			r[idx] = video.currentTime;;
			updateRange(selectedRange, r);
			clearTimeout(fixTid)
			fixTid = setTimeout( function(){
				fixTrack(selectedTrack, sel.id);
				$('.reporttr').removeClass('reportselected');
				$('#report'+sel.id).addClass('reportselected');
				$('#report'+sel.id+'_'+idx).addClass('time-sel');
				// reportSelect( sel.id );
			}, 200 )
			// report();
			console.log( 'adjust', sel )
            changed();
		}

	}
    function videoForward(ev,oneFrame)
    {
        var pos = video.currentTime + viewTotalLen/viewZoom/20;
        if( oneFrame ) pos = video.currentTime + .03;
        video.currentTime = pos;
		videoPosSel();
    }
    function videoRewind(ev,oneFrame)
    {
        var pos = video.currentTime - viewTotalLen/viewZoom/20;
        if( oneFrame ) pos = video.currentTime - .03;
        video.currentTime = pos;
		videoPosSel();
    }
    function videoRate( r )
    {
        video.playbackRate = r;
        var sr = Math.floor(r).toString();
        $('.trackrate').removeClass('trackrateselected')
        $('.v'+sr).addClass('trackrateselected');
    }

    function ftime( t, precision )
    {
        t += descriptor.media_time_offset;
        if( typeof(t) != 'number' || t == 0 || isNaN(t)) t = 0;
        var m = Math.floor(t/60);
        var h = Math.floor(m/60);
        var s = Math.floor(t);
        var ms = t-s;
        if( precision ) ms = ms.toFixed(precision).substr(1,1000);
        else ms = '';
        // console.log( t, s, ms )
        // if( s < 10 ) return s+ms;
        s = s % 60;
        var ft = s.toString().padStart(2,'0')+ms;
        if( 1 )
        {
            if( m < 10 ) return m+':'+ft;
            m = m % 60;
            ft = m.toString().padStart(2,'0') + ':' + ft;
        }
        if( h )
        {
            if( h < 10 ) return h+':'+ft;
            h = h % 60;
            ft = h.toString().padStart(2,'0') + ':' + ft;
        }
        return ft;
    }
    // var prec = 3;
    // console.log( 'ftime', ftime(0,prec) )
    // console.log( 'ftime', ftime(5.3,prec) )
    // console.log( 'ftime', ftime(15.3,prec) )
    // console.log( 'ftime', ftime(92.4,prec) )
    // console.log( 'ftime', ftime(60*60*2+60*30+14.1,prec) )

    // init video;
	var currentTrackName = null;
    var currentMedia = null;
    var zoom = 1;
    var zoomStart = 0;
    var zoomEnd = 1;
    var waveHeight = 100;
	if( tagData.DRMData ) // AWS DRM case
	{
		tagData.DRMData.dashPlayer();
	}
    else if( tagData.DRMURL ) // Normal DRM
    {
        const protData = {
            "com.widevine.alpha": {
                "serverURL": tagData.DRMServerURL
            }
        };
        var player = dashjs.MediaPlayer().create();
        var url = tagData.DRMURL;
        var appendUrl = '';
        if( url.indexOf('?') > 0 )
        {
            var tmp = url.split('?');
            appendUrl = tmp[1];
            url = tmp[0];
            player.extend("RequestModifier", function () {
                return {
                    modifyRequestHeader: function (xhr) {
						console.log( 'requestHeader', xhr )
                        // Add custom header. Requires to set up Access-Control-Allow-Headers in your
                        // response header in the server side. Reference: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
                        // xhr.setRequestHeader('DASH-CUSTOM-HEADER', 'MyValue');
                        return xhr;
                    },
                    // modifyRequestURL: function (url) {
                    //     // Modify url adding a custom query string parameter
                    //     return url + '?' + appendUrl;
                    // }
                };
            });
        }
        console.log( '========================================== DRM MODE ===============================================' );
        console.log( 'DRMURL', url );
        console.log( 'DRMURL_APPEND', appendUrl );
        console.log( 'DRMServerURL', tagData.DRMServerURL )
        console.log( '===================================================================================================' );
        mediaType = 'video';
        player.initialize(video, url, true);
        player.setProtectionData(protData);
    }
    else if (tagData.videoSource) {
        console.log('======================================== NORMAL MODE ==============================================');
        console.log('videoSource', tagData.videoSource);
        console.log('===================================================================================================');
        video.src = tagData.videoSource;
        // $(video).attr("loading","lazy")
        // .attr("preload","none")
        mediaType = 'video';
        // video.load();
        // alert(2)
        // video = $('#audio')[0];
    }
    else if (tagData.audioSource) {
        $('#video').hide();
        $('#videowraper').addClass('wavebg')
        video = $('#audio')[0];
        // video.ontimeupdate = videoPosUpdate;
        console.log('======================================== NORMAL MODE ==============================================');
        console.log('audioSource', tagData.audioSource);
        console.log('===================================================================================================');
        video.src = tagData.audioSource;
        mediaType = 'audio';
        // video.load();
        waveHeight = 300;
    }
    else {
        console.error('no video or audio source');
        return;
    }
    // console.log('VIDEO', video)
    var waveRegionColor = '#00ffff55';
    var waveRegionSelected = '#00000055';
    $('#wavecontainer').css({ background: 'red' })
    wavesurfer = window.WaveSurfer.create({
        container: '#waveform',
        waveColor: '#7367f0', // modify #0000 as #7367f0 -mani
        backgroundColor: '#fff', // modify #ddddd as #fff -mani
        progressColor: '#777777',
        // cursorWidth: 1,
        // fillParent: false,
        maxCanvasWidth: 1000,
        height: waveHeight,
        // barHeight: 1.5,
        plugins: [
            window.WaveSurfer.regions.create(),
            window.WaveSurfer.regions.create(),
            window.WaveSurfer.minimap.create({
                height: 40,
                waveColor: '##333',
                progressColor: '#999'
            }),
            window.WaveSurfer.timeline.create({
                backgroundColor: '#aaaaaa',
                container: '#waveformindex',
                timeInterval: 1000,

                formatTimeCallback: formatTimeCallback,
                primaryLabelInterval: 1,
            }),
            // WaveSurfer.cursor.create()
        ],
        backend: 'MediaElement',
        minPxPerSec: 160,
        scrollParent: true,
        autoCenter: true,
        mediaType: 'audio',
        mediaControls: true,
        normalize: true,
        // splitChannels: false,
    });
    // wavesurfer.load(tagData.audioSource);
    window.wavesurfer = wavesurfer;
    console.log( 'AUDIOSOURCE', descriptor.videoAudioSource  )
    wavesurfer.load( descriptor.videoAudioSource || video);
    // wavesurfer.load( video);
    wavesurfer.on('region-dblclick', waveRegionDblClick);
    wavesurfer.on('region-click', waveRegionClick);
        wavesurfer.on('region-update', waveRegionUpdateStart);
        wavesurfer.on('region-update-end', waveRegionUpdate);
    // wavesurfer.on('region-created', waveNewRegion);
    wavesurfer.on('region-in', waveRegionIn);
    wavesurfer.on('region-out', waveRegionOut);
    wavesurfer.on('seek', waveSeek);

    wavesurfer._setPlaybackRate = wavesurfer.setPlaybackRate;
    wavesurfer.setPlaybackRate = function( r ) {
        wavesurfer._setPlaybackRate( r/wavesurfer.durationRate );
        if( wavesurfer.durationRate > 1 ) video.playbackRate = r;
    }
    
    wavesurfer._setCurrentTime = wavesurfer.setCurrentTime;
    wavesurfer.setCurrentTime = function( r ) {
        // console.log( '_setCurrentTime', r )
        wavesurfer._setCurrentTime( r/wavesurfer.durationRate-wavesurfer.offset );
    }  

    wavesurfer._getCurrentTime = wavesurfer.getCurrentTime;
    wavesurfer.getCurrentTime = function() {
        return wavesurfer._getCurrentTime()*wavesurfer.durationRate+wavesurfer.offset;
    }  

    wavesurfer._getDuration = wavesurfer.getDuration;
    wavesurfer.getDuration = function() {
        return wavesurfer._getDuration()*wavesurfer.durationRate;
    }  

    wavesurfer._seekTo = wavesurfer.seekTo;
    wavesurfer.seekTo = function( r ) {
        if( !wavesurfer._sec ) r /= wavesurfer.durationRate;
        return wavesurfer._seekTo(r);
    }  

    wavesurfer._seekAndCenter = wavesurfer.seekAndCenter;
    wavesurfer.seekAndCenter = function( r ) {
        wavesurfer._sec = true;
        let ret = wavesurfer._seekAndCenter(r/wavesurfer.durationRate);
        wavesurfer._sec = false;
        return ret;
    }  

    wavesurfer._play = wavesurfer.play;
    wavesurfer.play = function( s, e ) {
        // if( !wavesurfer._sec ) r /= 10;
        if( typeof(s) == 'number' ) s /= wavesurfer.durationRate;
        if( typeof(e) == 'number' ) e /= wavesurfer.durationRate;
        console.trace( 'PPPPPPPPPPPPPPPLAY', s, e, wavesurfer._sec )
        return wavesurfer._play( s, e );
    }  

    function formatTimeCallback( t ) {
        if( !wavesurfer.durationRate ) return '';
        t *= wavesurfer.durationRate;

        t += descriptor.media_time_offset || 0;
        let h = Math.floor( t / 3600 );
        let m = Math.floor( (t % 3600) / 60  )
        let s = Math.round( t % 60 ).toString().padStart(2, '0');
        let tm = '';
        if( h > 0 ) {
            m = m.toString().padStart(2, '0');
            tm = [h,m,s].join(':');
        }
        else tm = [m,s].join(':');
        return tm;
        // return Math.floor(t / 60).toString() + '.' + Math.round(t % 60).toString().padStart(2, '0')
    }


    if( mediaType != 'audio' && descriptor.videoAudioSource ) {
        $('audio').hide();

        $(video).attr('controls', 'true').parent().on('mousedown', () => {
            console.log( 'mousedown')
            clearTimeout( videoClickTid );
            videoClick = true;
            videoClickTid = setTimeout( function(){ videoClick = false}, 300 )
        })
        video.addEventListener('mousedown', () => {
            console.log( 'videoclick')
        })
        video.addEventListener('play', (ev) => {
            // if( !videoClick ) return;
            console.log( 'videoplay', ev )
            if( !wavesurfer.isPlaying() ) {
                wavesurfer.play();
            }
            $('video')[0].blur();
        })
        video.addEventListener('pause', (ev) => {
            // if( !videoClick ) return;
            console.log( 'videopause', ev )
            if( wavesurfer.isPlaying() ) {
                wavesurfer.pause();
            }
            $('video')[0].blur();
        });
        video.addEventListener('seeking', (ev) => {
            if( seekPlaying === null ) seekPlaying = wavesurfer.isPlaying();
            // if( seekPlaying ) wavesurfer.pause();
            // console.log( 'seeking', seekPlaying )
            let dt = Math.abs(video.currentTime - wavesurfer.getCurrentTime())
            if( dt > 3 ) {
                wavesurfer.setCurrentTime( video.currentTime );
                wavePos(video.currentTime);
            }
        });
        video.addEventListener('seeked', (ev) => {
            // console.log( 'seeked')
            let dt = Math.abs(video.currentTime - wavesurfer.getCurrentTime())
            if( dt > 3 ) {
                wavesurfer.setCurrentTime( video.currentTime );
                wavePos(video.currentTime);
            }
            // if( seekPlaying ) wavesurfer.play();
            seekPlaying = null;
        });
        // video.addEventListener('timeupdate', (ev ) => {
        //     // if( !videoClick ) return;
        //     let dt = Math.abs(video.currentTime - wavesurfer.getCurrentTime())
        //     console.log( 'timeupdate', dt )
        //     // if( dt > 1 ) wavesurfer.setCurrentTime(video.currentTime)
        // })        
        // alert(1)
        // .on('pause', () => {
        //     if( !videoClick ) return;
        //     console.log( 'videopause' )
        // }).on( 'seek', ( pos ) => {
        //     console.log( 'videoseek', pos )
        // })
        
    }

    wavesurfer.enableDragSelection({
        color: waveRegionSelected,
        drag: false,
    });

    video.addEventListener('canplay', () => {
        // console.log('VIDEOREADY', video.duration )
        readyCheck();
    })

    // function waveNewRegion(region) {
    //     console.log('waveNewRegion', region);
    // }
    var waveOutTid = null;
    function waveRegionIn(region) {
        // // console.log('waveRegionIn', region);
        // clearTimeout(waveOutTid);
        // waveReportSelect(region.id)
    }
    function waveRegionOut(region) {
        // console.log('waveRegionOut', region);
        // waveOutTid = setTimeout(function () {
        //     waveReportUnselect(region.id)
        // }, 100)
    }
    var waveClickTid = null;
    function waveRegionClick(region) {
        console.log('waveRegionClick', region.id, region.start, region.end, clone(region.data));
        wavePause();
        waveClickTid = setTimeout(function () {
            var reg = waveRegionSelect(region);
            console.log( 'REGION', reg )
            waveRegionPlay(reg)
            waveRegionSelect(reg.id)
            wavePosCheck();
            if( currentMode.type != 'transcription' ) {
                var id = currentMode.options.indexOf( reg.data.tag );
                waveSegSelect(id);
            }
        }, 200)
    }
    function waveRegionDblClick(region) {
        clearTimeout(waveClickTid);
        console.log('waveRegionDblClick', region);
        if (currentMode.type =='transcription') waveTranscriptionText(region)
        else waveSegmentationEdit(region.data.tag)
        waveRegionSelect(region.id)
    }

    function waveFixRegions(region)
    {
        if( !region ) return;
        console.log( 'fix', region )
        var ranges = Object.values(wavesurfer.regions.list)
        var start = region.start;
        var end = region.end;
        for( var r of ranges )
        {
            if( r.id == region.id ) continue;
            if( r.start < end && r.start > start ) {
                console.log( 'fixStart', r.id )
                if( r.start < end ) end = r.start;
            }
            if( r.end > start && r.end < end ) {
                console.log( 'fixEnd', r.id )
                if( r.end > start ) start = r.end;
            }
        }
        waveRegionChange(region, { start: start, end: end })
    }

    function waveLinkRegions()
    {
        var ranges = Object.values(wavesurfer.regions.list)
        var sfunc = function (a, b) {
            if (a.start == b.start) return a.end > b.end ? 1 : -1;
            return a.start > b.start ? 1 : -1;
        }
        ranges.sort(sfunc);
        var lr = null;
        ranges.forEach(r => {
            r.data.next = r.data.prev = null;
            // console.log( r.id, r.start, r.end );
            if( lr && lr.end == r.start )
            {
                lr.data.next = r.id;
                r.data.prev = lr.id;
                // console.log( '-------------------link', lr.id, r.id )
            }
            lr = r;
        } )
    }


    function waveRegionUpdateStart(region) {
        if( descriptor.blockEdit ) return;
        console.log('waveRegionUpdateStart', region.id, region.start, region.end );
    }
    function waveRegionUpdate(region) {
        if( descriptor.blockEdit ) {
            for( let w in wavesurfer.regions.list ) {
                let r = wavesurfer.regions.list[w]
                if( !r.data.text ) r.remove();
            }
            return;
        }
        console.log('waveRegionUpdate', region );
        if (!region.data || !region.data.track) {
            if (currentMode.type == 'transcription') {
                waveFixRegions(waveRegion(region.id));
                waveLinkRegions();
                region = waveRegion(region.id);
                waveRegionPlay(region)
                waveTranscriptionText(region)
            }
            else {
                waveRegionSelect(null);
                region.data.track = currentMode.name;
                region.data.tag = currentMode.options[currentSeg];
                region.color = region.data.regionColor = currentMode.colors[currentSeg] + waveTransparency;
                waveRegionChange(region, region.data);
                waveFixRegions(waveRegion(region.id));
                waveLinkRegions();
                waveReport();
                changed();
            }

            // waveFixRegions(region);
            // waveLinkRegions();
            // waveReport();
        }
        else {
            if (region.data.prev) {
                waveRegionChange(waveRegion(region.data.prev), { end: region.start })
            }
            if (region.data.next) {
                waveRegionChange(waveRegion(region.data.next), { start: region.end })
            }
            waveFixRegions(region);
            waveLinkRegions();
            waveReport();
            changed();
        }
    }
    function waveRegion(id) {
        return wavesurfer.regions.list[id] || null;
    }

    function waveRegionText( id, txt ) {
        var reg = $('[data-id="'+id+'"]');
        reg.find('.wave-region-title').remove();
        reg.append( $('<div class="wave-region-title">').html(txt))
        reg.find('.wave-region-title').css({width: 200})
    }

    function waveRegionChange(region, val) {
        if( !region ) return;
        for (var k in val) region[k] = val[k];
        region.showTooltip = 'test';
        region.remove();

        // if( descriptor.allow_media_regions === false && descriptor.allow_media_markers ) {
        //     region.end = region.start;
        // }
        // if( descriptor.allow_media_regions === false && descriptor.allow_media_markers === false ) return;
        if( region.start < region.end && !descriptor.allow_media_regions  ) return;
        var r = wavesurfer.addRegion(region);
        waveRegionText( r.id, r.data && (r.data.text || r.data.tag) || '');
        return r;
    }
    function waveRegionSelect(region) {
        if (isobj(region)) region = region.id;
        if (wavesurfer.selectedRegion) {
            var oreg = waveRegion(wavesurfer.selectedRegion);
            if( oreg ) {
                waveRegionChange(oreg,
                    { color: oreg.data.regionColor })
            }
        }
        wavesurfer.selectedRegion = region;
        if (region) {
            var reg = waveRegion(wavesurfer.selectedRegion);
            return waveRegionChange(reg,
                { color: waveRegionSelected })
        }
    }

    function waveRegionPlay( region ) {
        // console.log( 'waveRegionPlay', region )
        // region.play();
        if( !region ) return;
        if( region.start == region.end ) {
            video.currentTime = region.start;
            wavePos(region.start)
            window.rrr = region;
            wavePosCheck()
        } else {
            region.play();
        }
    }

    
    frm.loading('Loading Media')
    wavesurfer.on('play', wavePlayStart);
    wavesurfer.on('pause', wavePaused);
    wavesurfer.on('volume', (a) => {
        // if( mediaType != 'audio') wavesurfer.setVolume(0.0000001)
    })


    $('.wavecontainer').on('mousedown', () => {
        wsclicked = true;
        // console.log( 'mousedown', wsclicked)
    }).on('mouseup', () => {
        setTimeout( function(){
            wsclicked = false;
            // console.log( 'mouseup', wsclicked)
        }, 1);
    })

    var wavePlayTid = null;
    function wavePlayStart( a, b ){
        console.log( 'play', a, b )
        video.currentTime = wavesurfer.getCurrentTime();
        if( mediaType != 'audio' && descriptor.videoAudioSource ) wavesurfer.setVolume(0.0000001)
        wavesurfer.isMuted = true;
        if( video.paused ) video.play();
        waveTime();
    }

    window.audioObj = audioObj;

    function wavePosCheck(deb) {
        // console.log( 'wavePostCheck')
                var t = wavesurfer.getCurrentTime();
        for( var k in wavesurfer.regions.list )
        {
            var r = waveRegion(k);
            let prec = 0.001;
            if( deb ) console.log( 'start', r.start, 'end', r.end, 'pos', t, r.start-prec < t, r.end+prec >= t, r.start-prec < t && r.end+prec >= t )
            if( r.start-prec < t && r.end+prec >= t ) {
                console.log( 'reg', k, r.id, r.start, r.end, t )
                return waveReportSelect(r.id)
            }
        }
        waveReportUnselect()

    }
    window.wavePosCheck = wavePosCheck;
    window.waveReportSelect  = waveReportSelect;

    function waveTime() {
        clearTimeout( wavePlayTid );
        wavePosCheck();
        wavePlayTid = setTimeout( waveTime, 100 );
    }
    function wavePaused() {
        clearTimeout( wavePlayTid );
        if( !video.paused ) 
        video.pause();
        
        console.log('paused')
        // if (wavesurfer.selectedRegion) {
        //     waveLastReportSelect = null;
        //     console.log('sel', wavesurfer.selectedRegion)
        //     clearTimeout(waveOutTid);
        //     setTimeout(function () {
        //         waveReportSelect(wavesurfer.selectedRegion)

        //     }, 10)
        // }
    }

    wavesurfer.mySeek = function () { }

    // wavesurfer.seekTo = waveClick;

    function waveAddMarker( start ) {
        let rid = wavesurfer.addRegion({
            start: start,
            end: start,
            color: waveRegionColor,
            drag: false,
            data: {
                regionColor: waveRegionColor,
            }
        })
        console.log( 'region', rid )
        waveRegionDblClick( rid );
    }

    function waveSeek(pos, a, b ) {
        console.log( 'waveseek', pos, 'clicked', wsclicked, wavesurfer._sec )
        // return;
        if( wsclicked ) {
            video.currentTime = wavesurfer.getCurrentTime();
            if( descriptor.allow_media_markers ) waveAddMarker( wavesurfer.getCurrentTime() )
        }
        wavePosCheck();
        if (waveStartSelect || waveEndSelect) return;
        waveRegionSelect(null);
    }

    var lastPos = -1;
    var lastZoom = -1;
    function wavePos(pos, zoom) {
        var r = pos / wavesurfer.getDuration();
        console.log('wavePos', pos, r)
        wavesurfer.seekAndCenter(r);
    }
    window.wavePos = wavePos;
    var waveReady = false;
    wavesurfer.on('ready', function () {
        // console.log( 'READY', wavesurfer.getDuration(), video.duration )
        readyCheck();
    })

    function readyCheck() {
        // console.log( 'READYCHECK', video.duration, wavesurfer._getDuration() );
        if( waveReady ) return;
        if( video.duration > 0 &&  wavesurfer._getDuration() > 0 ) {
            wavesurfer.offset = 0
            wavesurfer.durationRate = Math.round(video.duration/wavesurfer._getDuration())
            console.log( 'READYDONE', wavesurfer.durationRate )
            frm.loadingOut();
            waveReady = true;
            wavesurfer.timeline.params.timeInterval = 1/wavesurfer.durationRate
            setHeight();
            $(document.body).off('keydown').on('keydown', keyDown);
            $(document.body).off('keyup').on('keyup', keyUp);
            $(document.body).off('mousedown').off('mouseup').off('mousemove').on('click')
            waveModeSelect();
            wavePanel();
        }
    }

    function wavePause() {
        console.log( 'wavePause')
        video.pause();
        wavesurfer.pause();
    }

    function wavePlay() {

        wavesurfer.play();
    }

    function waveTranscriptionText(region) {
        if (!region) return;


        var text = region.data.text || '';
        var params = ['Annotation Text', '', '^Set Text', saveText];
        if (region.data.track) params = params.concat(['*Delete Text', remove])
        params = params.concat(['Cancel', cancel])
        myAlert.apply(this, params);
        var desc = $('<div class="question-field field"><div class="err"></div>').append($('<TEXTAREA id="tag-text" class="inote-text mt-2"></div>').prop('placeholder', 'Enter Transcription Text').val(text));
        $('.modal-body').html('').append(desc);
        setTimeout(function () {
            $('#tag-text').select().on('keydown', function (ev) {
                if (ev.keyCode == 13) saveText();
            })
        }, 500)
        function cancel() {
            if (!region.data.track) remove();
            waveReport();
        }
        function remove() {
            region = waveRegion(region.id);
            wavesurfer.selectedRange = null;
            // waveRegionChange( region, {color:'#ff000055'})
            region.remove();
            changed();
            waveReport();
        }
        function saveText(ev) {
            var text = $('#tag-text').val().trim();
            if (!text) {
                $('.modal-body').find('.err').html('Enter the transcription text');
                cancelEvent(ev)
                return true;
            }
            region.data.text = text;
            region.data.confidence = 1;
            region.data.track = 'Transcription';
            region.data.regionColor = waveRegionColor;
            changed();
            myAlertClose();
            let rsel = waveRegionSelect(region)
            waveRegionPlay( rsel )
            waveRegionSelect( rsel.id )
            waveReport();

        }
    }

    function wavePlayPause() {
        if (wavesurfer.isPlaying())
            wavePause();
        else
            wavePlay();
    }

    function waveAdvance(v) {
        if (waveStartSelect || waveEndSelect) v = 1 / 30 * v;
        else v /= 2;
        var p = wavesurfer.getCurrentTime() + v;
        if (p < 0) p = 0;
        if (p > wavesurfer.getDuration()) p = wavesurfer.getDuration()
        if (waveStartSelect) waveRegionChange(waveRegion(wavesurfer.selectedRegion), { start: p })
        else if (waveEndSelect) waveRegionChange(waveRegion(wavesurfer.selectedRegion), { end: p })
        waveFixRegions(waveRegion(wavesurfer.selectedRegion));
        waveLinkRegions();
        wavePos(p);
        video.currentTime = p;
        $('video')[0].blur();
    }

    function waveRemoveSelected() {
        if( blockEdit ) return;
        if (wavesurfer.selectedRegion) {
            wavesurfer.regions.list[wavesurfer.selectedRegion].remove();
            wavesurfer.selectedRegion = null;
            changed();
            waveLinkRegions();
            waveReport();
        }
    }

    var waveZoom = 16;
    function waveZoomIn() {
        if (waveZoom >= 256) return;
        waveZoom *= 2;
        waveZoomUpdate();
    }

    var waveZoomMin = 1/64;
    function waveZoomOut() {
        if (waveZoom <= waveZoomMin ) {
            waveZoom = waveZoomMin;
            return;
        }
        waveZoom /= 2;
        waveZoomUpdate();
    }
    function waveZoomUpdate() {
        wavesurfer.zoom( waveZoom*10);
        var sz = waveZoom;
        if( sz < 1 ) sz = sz.toFixed(2);
        console.log( 'waveZoomUpdate', sz+'X')
        $('.wave-zoom-txt').html(sz+'X');
    }

    function wavePanel()
    {
        $('.wavepanel').remove();
        var wp = $('<DIV>').addClass('wavepanel');
        var speed = $('<span>Speed:</span>');
        var v05x = $('<div>').prop('id', 'v05x').addClass('wave-rate v0 unselectable').html('0.5X');
        var v1x = $('<div>').prop('id', 'v1x').addClass('wave-rate v1 unselectable').html('1X');
        var v2x = $('<div>').prop('id', 'v2x').addClass('wave-rate v2 unselectable').html('2X');
        var v4x = $('<div>').prop('id', 'v4x').addClass('wave-rate v4 unselectable').html('4X');
        var v8x = $('<div>').prop('id', 'v8x').addClass('wave-rate v8 unselectable').html('8X');
        var tzoom = $('<span class="trackr">Track zoom: </span>');
        var czommIn = $('<div>').addClass('wave-zoom-in unselectable').html('<i class="fa fa-plus"></i>').click(waveZoomIn);
        var czoomTxt = $('<div>').addClass('wave-zoom-txt unselectable').html('');
        var czoomOut = $('<div>').addClass('wave-zoom-out unselectable').html('<i class="fa fa-minus"></i>').click(waveZoomOut);
        v05x.on('click',function () { waveRate(0.5) });
        v1x.on('click',function () { waveRate(1) });
        v2x.on('click',function () { waveRate(2) });
        v4x.on('click',function () { waveRate(4) });
        v8x.on('click',function () { waveRate(8) });
        wp.append( speed, /*v05x,*/ v1x, v2x, v4x, v8x, tzoom, czommIn, czoomTxt, czoomOut );
        $('.waveinterface').append(wp);
        waveRate(1);
        waveZoom = 16;
        waveZoomUpdate();
    }

    function waveRate(r) {
        wavesurfer.setPlaybackRate(r);
        var sr = Math.floor(r).toString();
        $('.wave-rate').removeClass('wave-rate-selected')
        $('.v' + sr).addClass('wave-rate-selected');
    }


    var waveLastReportSelect = null;
    var waveStartSelect = null;
    var waveEndSelect = null;
    function waveReport() {
        // console.log('wavereport', reportObj, trackList)
        if (!reportObj) return;
        // tagData.streams[currentTrackName] = [];
        var ranges = [];
        for (var k in wavesurfer.regions.list) {
            var r = wavesurfer.regions.list[k];
            if (!r.data.track) continue;
            // var [name, category] = r.data.track.split(txtSeparator);
            var robj = {
                id: k,
                start: r.start,
                end: r.end,
                tag: r.data.tag,
                // category: category,
                text: r.data.text,
                confidence: r.data.confidence,
            }
            ranges.push(robj);
        }

        window.ranges = allRanges = ranges;
        var sfunc = function (a, b) {
            if (a.category == b.category) {
                if (a.start == b.start) return a.end > b.end ? 1 : -1;
                return a.start > b.start ? 1 : -1;
            }
            else return a.category > b.category ? 1 : -1;
        };

        if (questionMode) sfunc = function (a, b) {
            if (a.start == b.start) return a.end > b.end ? 1 : -1;
            return a.start > b.start ? 1 : -1;
        }
        ranges.sort(sfunc);

        // console.log('ranges', ranges)

        reportObj.html('');
        if (!ranges.length) return reportObj.html('<span class="tag-panel-empty">(no annotations)</span>');
        var tab = $('<TABLE>').addClass('reporttable');
        var thead = $('<THEAD>');
        var tr = $('<TR>');
        tr.append($('<TH>').html('Start'));
        tr.append($('<TH>').html('-'));
        tr.append($('<TH>').html('End'));
        tr.append($('<TH>').html(currentMode.type == 'transcription' ? 'Text' : currentMode.name));
        thead.append(tr);
        tab.append(thead);
        // var streams = {};
        ranges.forEach(function (r) {
            // if (!questionMode) {
            //     // var tmp = r.tag.split(txtSeparator);
            //     // var category = tmp[0];
            //     var tag = r.tag;
            //     if (!streams[category]) streams[category] = [];
            //     var sobj = { id: tag, start: r.start, end: r.end };
            //     if (currentMode.type == 'transcription') sobj.text = r.text;
            //     streams[category].push(sobj);
            // }
            var tr = $('<TR>').prop('id', 'wavereport' + r.id).addClass('reporttr');
            if( r.confidence < descriptor.confidenceThreshold ) tr.addClass('reportcheck')
            if (currentMode.type == 'transcription') tr.prop('text', r.text);
            tr.append($('<TD>').prop('id', 'wavereport' + r.id + '_0').html(ftime(r.start, 1)).dblclick(rstart));
            if( r.start == r.end ) {
                tr.append($('<TD>').html('&nbsp;'));
                tr.append($('<TD>').prop('id', 'wavereport' + r.id + '_1').html('&nbsp;').dblclick(rend));
            }
            else {
                tr.append($('<TD>').html('-'));
                tr.append($('<TD>').prop('id', 'wavereport' + r.id + '_1').html(ftime(r.end, 1)).dblclick(rend));
            }
            tr.append($('<TD>').html(currentMode.type == 'transcription' ? r.text : r.tag));
            tab.append(tr);
            var clickTid = null;
            tr.click(function () {
                wavePause();
                console.log('repor click', r.id);
                waveReportSelect(r.id);
                if (!clickTid) {
                    clickTid = setTimeout(function () {
                        console.log('PLAY')
                        let rsel = waveRegion(r.id)
                        waveRegionPlay( rsel )
                        waveRegionSelect( rsel.id )
                        // playRange($('#' + r.id));
                        clickTid = null;
                    }, 300);
                }
                console.log('play', clickTid)
            })
            tr.dblclick(function () {
                console.log('double', r.id)
                clearTimeout(clickTid);
                clickTid = null;
                waveRegionDblClick( waveRegion(r.id) );
                // waveReportSelect(r.id);
                // transcriptionText(r.id)
            });

            function rstart(ev) {
                waveStartSelect = r;
                waveReportSelect(r.id);
                console.log('rstart', r.id)
                clearTimeout(clickTid);
                waveRegionSelect(r.id)
                clickTid = null;
                $('.time-sel').removeClass('time-sel')
                $(this).addClass('time-sel')
                videoPause();
                video.currentTime = r.start;
                // selectRange($('#' + r.id))
                return false;
            }

            function rend(ev) {
                waveEndSelect = r;
                console.log('rend', r.id )
                waveReportSelect(r.id);
                clearTimeout(clickTid);
                clickTid = null;
                waveRegionSelect(r.id)
                $('.time-sel').removeClass('time-sel')
                $(this).addClass('time-sel')
                videoPause();
                video.currentTime = r.end;
                // selectRange($('#' + r.id))
                return false;
            }
        });
        waveReportUnselect();
        // tagData.streams = streams;
        reportObj.html('').append(tab);
        // console.log( ranges );
    }

    function waveReportSelect(id) {
        if (id == waveLastReportSelect) return;
        // console.log( 'waveReportSelect', id );
        waveStartSelect = null;
        waveEndSelect = null;
        $('.time-sel').removeClass('time-sel')
        waveLastReportSelect = id;
        console.log( 'waveReportSelect', id )
        $('.reporttr').removeClass('reportselected');
        if (!$('#wavereport' + id).length) return;
        console.log( '2')
        $('#wavereport' + id).addClass('reportselected');
        var top = $('#wavereport' + id).position().top;
        console.log( 'top', top )
        $('#reportpanel').scrollTop(top - $('#reportpanel').height() / 2);
        var text = $('#wavereport' + id).prop('text');
        if (text) $('#subtitles').html('<span>' + text + '</span>');
    }

    function waveReportUnselect() {
        $('#subtitles').html('')
        $('.reporttr').removeClass('reportselected');
        waveLastReportSelect = null;
    }

    window.waveModeSelect = waveModeSelect;

    function waveModeSelect() {
        if( (descriptor.metadata) ) {
            let m = descriptor.media.metadata || {};
            for( let k in descriptor.metadata ) m[k] = descriptor.metadata[k];
            descriptor.metadata = m;
        }
        if( descriptor.metadata ) {
            $('.media-metadata').html('');
            var out = [];
            for( var k in descriptor.metadata ) {
                out.push( '<b>'+k+':</b>' );
                out.push( descriptor.metadata[k] )
            }
            $('.media-metadata').html(out.join(' '));
            let metadata = descriptor.media.metadata;
            let info = $('.media-metadata');
            console.log( 'metadata', metadata )
            info.attr('title',info.text()).off('click').on('click', function(ev) {
                if( ev.ctrlKey ){
                    if( metadata.TaskId ) {
                        var md = metadata.TaskId;
                        var msg = 'Task Id Saved to clipboard';
                    }
                    else if( metadata.ItemId ) {
                        var md = metadata.ItemId;
                        var msg = 'Dataset Item Id Saved to clipboard';
                    }
                }
                else {
                    var md = JSON.stringify(metadata,null,'\t');
                    var msg = 'The task matadata was copied to the clipboard';
                }
                saveClipboard( md );
                frm.myAlert('Metadata Copied', msg, 'Ok')
                setTimeout( function(){
                    $("#modal-close")[0].click();
                }, 3000  )
            })


        }
        if( totalModes.length == 1 ) return waveMode(0);
        // var modeSel = $('<SELECT id="modesel" style="width: auto">').addClass('form-control video-toolbar-content ml-1 mr-1');

        // totalModes.forEach( (m, idx) => modeSel.append( $('<option>').val(idx).html(m.mode) ) );
        let modeOpt = totalModes.map( (m, idx) =>  ({label:m.mode, value:idx}) );


        // modeSel.on('change', function(){ modeSel[0].blur(); waveMode($(this).val())} );
        // $('.mode-select').html('<span>Mode: </span>').append(modeSel);
        $('.mode-select').html('<span>Mode: </span>');
        var id = 0;
        window.modeSelDrop = modeSelDrop = frm.dropDown($('.mode-select'), modeOpt, null, {width: 200}, (v) => {
            waveMode(v)
        }) .addClass('imgcls-dropdown-value');// modify imgcls-dropdown-key to imgcls-dropdown-value 27/2 mani
        // id = totalModes.length-1;
        // modeSel.val(id);
        waveMode(id);
        // frm.convertSelects();
    }


    var waveTransparency = '77';

    function waveSegSelect(id) {
        $('.segmentation-opt').removeClass('segmentation-opt-sel').css({background:''});
        $('#segbtn' + id).addClass('segmentation-opt-sel').css({background:currentMode.colors[id]+waveTransparency});
        if (id !== null) wavesurfer.enableDragSelection({
            color: waveRegionSelected,
            drag: false,
        });
        else wavesurfer.disableDragSelection();
        currentSeg = id;

        if (wavesurfer.selectedRegion) {
            var region = waveRegion(wavesurfer.selectedRegion);
            var tag = currentMode.options[currentSeg];
            if( region.data.tag == tag ) return;
            region.data.tag = tag;
            region.color = region.data.regionColor = currentMode.colors[currentSeg] + waveTransparency;
            waveRegionChange(region, region.data);
            wavesurfer.selectedRegion = null;
            waveFixRegions(waveRegion(region.id));
            waveLinkRegions();
            waveReport();
            changed();
        }
    }

    function waveSegmentationEdit(tag) {
        console.log( 'waveSegmentationEdit', tag )
        if (!tag) tag = '';
        if( !currentMode.editable ) return;

        var id = currentMode.options.indexOf(tag);
        if( tag && id == -1 ) return
        var params = ['Segmentation Tag Label', '', '^Set Tag', saveTag];
        if( tag > '' ) params = params.concat(['*Delete Tag', remove])
        params = params.concat(['Cancel', cancel])
        myAlert.apply(this, params);
        var desc = $('<div class="question-field field"><div class="err"></div>').append($('<TEXTAREA id="tag-text" class="inote-text mt-2"></div>').prop('placeholder', 'Enter Transcription Text').val(tag));
        $('.modal-body').html('').append(desc);
        setTimeout(function () {
            $('#tag-text').select().on('keydown', function (ev) {
                if (ev.keyCode == 13) saveTag();
            })
        }, 500)
        function cancel(ev) {
        }
        function remove(ev) {
            cancelEvent(ev);
            var delRegions = [];
            var oldTag = currentMode.options[id];
            var rlist = wavesurfer.regions.list;
            for (var k in rlist) {
                var region = rlist[k];
                if (region.data.tag == oldTag) {
                    delRegions.push( region );
                }
            }
            console.log( 'delRegions', delRegions )
            function tagDel() {
                currentMode.options.splice(id,1);
                for( var r of delRegions ) r.remove();
                exportData(true);
                waveModeReload();
                myAlertClose();
                changed();
            }
            if (!delRegions.length) tagDel();
            else {
                myAlertClose(function () {
                    myAlert('Delete Tag', 'There are annotations assigned to this tag. Confirm deletion?', '*Delete', tagDel, 'Cancel', function(){});
                })
            }
        }
        function saveTag(ev) {
            var tag = $('#tag-text').val().trim();
            if (!tag) {
                $('.modal-body').find('.err').html('Enter the tag name');
                cancelEvent(ev);
                return true;
            }
            var nid = currentMode.options.indexOf(tag);
            if ( nid != -1 && ( id == -1 || tag != currentMode.options[id]) ) {
                console.log( 'TAKEN', nid, id, nid != -1, tag != oldTag, tag, oldTag )
                return myAlertClose(function () {
                    myAlert('Tag already taken', 'The tag <b>' + tag + '</b> already exists. Choose another name.', 'Ok')
                });
            }
            if (id >= 0) {
                var oldTag = currentMode.options[id];

                var rlist = wavesurfer.regions.list;
                for (var k in rlist) {
                    var region = rlist[k];
                    if (region.data.tag == oldTag) {
                        console.log('edit', region.id, region.data)
                        region.data.tag = tag;
                        waveRegionChange(region, { data: region.data });
                        changed();
                    }
                }
                currentMode.options[id] = tag;
            }
            else {
                id = currentMode.options.length; 
                currentMode.options.push( tag );
                setTimeout( function(){ waveSegSelect(id) },100 )
            }
            exportData(true);
            waveModeReload();
            myAlertClose();
            changed();
            // alert(tag)
            // region.data.text = text;
            // region.data.confidence = 1;
            // region.data.track = 'Transcription';
            // region.data.regionColor = waveRegionColor;
            // changed();
            // waveRegionPlay(rwaveRegionSelect(region))
        }
    }

    function waveSegmentation( id, name, color ){
        if( descriptor.blockEdit ) return $('.segmentation').hide();
        var seg = $('<div>').html(name).prop('id','segbtn'+id).addClass('segmentation-opt unselectable').css({borderLeftColor: color})
        seg.on('click', function(){
            waveSegSelect( id );
        }).dblclick( function(){ waveSegmentationEdit(name)});
        $('.segmentation').append( seg );
    }


    window.waveMode = descriptor.waveMode = waveMode = function(m, force) {
        // console.log( 'waveMode', m )
        if( !force && currentMode == totalModes[m] ) return;
        if( currentMode ) exportData(true);
        currentMode = totalModes[m];
        descriptor.currentMode = currentMode;
        $('#modesel').val(m)
        // currentMode.id = m;
        currentTrackName = currentMode.name;
        wavesurfer.selectedRegion = null;
        $('.segmentation').html('');
        if( currentMode.type != 'transcription' && isarray(currentMode.options) ) {
            console.log( 'aaaaaaaaaaaaa', currentMode.options)
            wavesurfer.disableDragSelection();
            var colors = paletteWheel( currentMode.options.length );
            currentMode.colors = colors;
            currentMode.options.forEach( (o,i) => {
                waveSegmentation( i, o, colors[i%colors.length] );
            })
            if( currentMode.allowNew ) {
                var plus = $('<div class="segmentation-plus">').html('<i class="fa fa-plus-circle"></i> Add Segmentation');
                plus.on('click', function(){ waveSegmentationEdit('') } );
                $('.segmentation').append( plus );
            }
        }
        else wavesurfer.enableDragSelection({
            color: waveRegionSelected,
            drag: false,
        });
        currentSeg = null;
        waveLoaded = false;
        waveLoadData();
    }

    function waveModeReload() {
        var id = currentMode.id;
        currentMode = null;
        waveMode(id);
    }

    window.waveMode = waveMode;



    var waveLoaded = false;
    function waveLoadData() {
        if( !descriptor.confidenceThreshold ) descriptor.confidenceThreshold = 0.8;
        if( waveLoaded ) return;
        waveLoaded = true;
        wavesurfer.clearRegions()
        if (!descriptor.streams) return;
        var t = currentTrackName;
        var insertedOption = false;
        if( descriptor.streams[t] ) {
            for (var r of descriptor.streams[t]) {
                var color = waveRegionColor;
                if( currentMode.type != 'transcription' ) {
                    var id = currentMode.options.indexOf(r.tag);
                    if( id == -1 ) {
                        id = currentMode.options.length;
                        currentMode.options.push(r.tag);
                        insertedOption = true;
                    }
                    color = currentMode.colors[id]+waveTransparency;
                }
                wavesurfer.addRegion({
                    start: r.start,
                    end: r.end,
                    color: color,
                    drag: false,
                    data: {
                        regionColor: color,
                        track: t,
                        text: r.text,
                        tag: r.tag,
                        confidence: r.confidence,
                    }
                })
            }

            Object.values(wavesurfer.regions.list).forEach( r => waveRegionText( r.id, r.data && (r.data.text || r.data.tag) || '') );
        }
        if( insertedOption ) return waveModeReload();
        waveLinkRegions();
        waveReport();
    }

    function videoCheckInit()
    {
        return;
        // console.log( 'videoCheckInit', 'fg...', video.duration, !video.duration || isNaN(video.duration));
        // if( !video.duration || isNaN(video.duration)) {
        //     console.log( 'will check again')
        //     return setTimeout( videoCheckInit, 100 );
        // } 
        // console.log( 'VIDEO DURATION', video.duration );
        // videoPause();
        // videoPos(0);
        // videoPosUpdate();
        // videoRate(1);
        // panel.show();
        // $(document.body).on('keydown', keyDown );
        // $(document.body).on('keyup', keyUp );
        // setHeight();
        // viewTotalLen = video.duration;
        // var transcriptZoom = 1;
        // for( var i = 0, d = 60 ; i < 4 ; i++, d*=2 )
        //     if( video.duration > d ) transcriptZoom *= 2;
        // view( 0, transcriptionMode ? transcriptZoom : 1 );
        // zoomUpdate();
    }
    window.videoCheckInit  = videoCheckInit;
    

    // control component height to fit screen without scrolling
    var lastHeight = 0;
    var lastWidth = 0;
    var contentHeight = 0;
    var contentWidth = 0;
    function setHeight()
    {
        // console.log( 'setHeight' )
        if( !$('#videopanel').length ) return;
        var minh = 200;
		if( transcriptionMode ) minh = 135;
        var top = content.position().top;
		// var top = tracks..getBoundingClientRect();
        var wh = $(window).height()-$('.video-toolbar').outerHeight();
        if( mode != 'template' ) wh -= 165
        // wh -= 120;

        // var wavH = 190;
        var wavH = 90+$('.mainnav').outerHeight();
        var segH = $('.segmentation').outerHeight() || 0;
        var vh = wh-wavH-segH;
        if( mediaType == 'video' ) $(video).css({height:vh})


        // $('#videopanel').css({height:wh});
        // console.log( 'top', top,'wh', wh )
        var h = wh-top-5;
        if( h < minh ) h = minh;

        var cursorTop = ruler.position().top;
        var cursorHeight = wh-h+1000;
        // console.log( 'cursorTop', cursorTop, cursorHeight );
        cursor.css({top:px(cursorTop), height:px(cursorHeight)});

        $('#videowraper').css({minHeight: 50})

		var versionSpan = $('#version');
		var vh = versionSpan.length ? versionSpan.outerHeight() : 0;
		var rightHeight = wh-($('#right1').position().top+$('#right1').outerHeight()+ $('#right2').outerHeight() +vh)-30;
        if (rightHeight < 180) rightHeight = 180;
        $('#t_right').css({ height: wh });
		$('#reportpanel').css({height:rightHeight,overflowY:'auto'})
        content.css({height:px(h)});
        contentHeight = h;
        contentWidth = content.width();
        var top = tracks.position().top;
        var wh = content.height();
        var h = wh-top-10;
        // console.log( 'top', top,'wh', wh )
        tracks.css({height:px(h),overflowY:'auto'});
        // content.css()
        if( contentHeight != lastHeight || contentWidth != lastWidth )
        {
            lastHeight = contentHeight;
            lastWidth = contentWidth;
            view( viewPos, viewZoom );
        }
        clearTimeout( setHeightTid );
        setHeightTid = setTimeout( setHeight, 1000 );
    }
    var playing = false;

    var lastKey = null;
    function keyUp(e)
    {
		if( e.target.tagName.match(/(INPUT|TEXTAREA)/)) return;
        if( !e.shiftKey ) window.shiftKey = false;
        if( !e.ctrlKey ) window.ctrlKey = false;
        if( !e.altKey ) window.altKey = false;
    }
    function keyDown(e)
    {
        // console.log( 'keyDown', e.keyCode )
		if( e.target.tagName.match(/(INPUT|TEXTAREA)/)) return;
        var key = e.keyCode;
        var dt = 1;
        if( e.shiftKey ) window.shiftKey = true;
        if( e.ctrlKey ) window.ctrlKey = true;
        if( e.altKey ) window.altKey = true;
        // if(  key == lastKey )
        // {
        //     if( (Date.now()-lastKeyTs) < 200 )
        //         var dt = 4+lastDt++
        //     else
        //         var dt = lastDt = 1;
        // }
        // console.log( e.keyCode, dt );
        if( key == 32 )
        {
            // if( video.paused )
            //      videoPlay();
            // else videoPause();
            wavePlayPause();
            return false;
        }
		else if( key == 36 ) // home
		{
            wavePos( 0 );
			// video.currentTime = 0;
		}
        else if( key == 37 ) // left
        {
            waveAdvance( -1 );
            // videoRewind(null,1);
        }
        else if( key == 39 ) // right
        {
            waveAdvance( 1 );
            // videoForward(null,1);
        }
        else if( (e.keyCode == 46 || e.key == 46 || e.witch == 46 || e.keyCode == 8 || e.key == 8 || e.witch == 8) )
        {
            waveRemoveSelected();
            // if( selectedRange ) return deleteRange(selectedRange);
            // if( selectedTrack ) return deleteTrack(selectedTrack);
        }
    }

    var lastZoom = 0;
    var viewPos = 0;
    var viewOffset = 0;
    var viewTotalLen = 0;
    var viewZoom = 0;
    var viewLeft = 0;
    function view( pos, zoom )
    {
        // console.log( 'view', pos, zoom );
        if( pos > video.duration ) return console.error( 'position is longer then full media duration')

        viewZoom = zoom;
        viewPos = pos;
        var vsize=contentWidth*viewZoom;
        if( vsize != lastZoom )
        {
            drawTracks();
            lastZoom = vsize;
        }
        var dt = viewTotalLen/viewZoom;
        viewLeft = -contentWidth/dt*viewPos;
        var end = viewLeft+ruler.width();
        if( end < contentWidth ) viewLeft += contentWidth-end;
        // console.log( 'margin', viewLeft, px(viewLeft) );
        ruler.css({left:px(viewLeft)});
        $('.track').css({left:px(viewLeft),width:px(ruler.width())});
        $('.tracklabel').css({left:px(-viewLeft)});

        // if (window.wavePos) {
        //     var wPos = viewPos / viewTotalLen;
        //     var maxPos = 1 - 1 / viewZoom;
        //     if (wPos > maxPos) wPos = maxPos;
        //     window.wavePos(wPos, viewZoom)
        // }
        posCursor();
    }
    // gruler = ruler;
    var followView = true;

    function posCursor(tms)
    {
        if (video.currentTime == video.duration) {
            cursor.hide();
            return;
        }
        var dt = viewTotalLen / viewZoom;
        var cpos = contentWidth / dt * video.currentTime + viewLeft;
        var css = { left: cpos };
        if (tms) {
            var trans = 'left ' + tms / 1000 + 's';
            // console.log( tms, trans );
            css.transition = trans;
        }
        cursor.css(css).show();
        if (followView && cpos < 0 || cpos > contentWidth) {
            view(video.currentTime, viewZoom);
        }
        // if( window.wavePos ) {
        //     var wPos = video.currentTime / video.duration;
        //     if( !isNaN( wPos ) ) wavesurfer.mySeek(wPos);
        // }
        // var l =
    }

    function calcTime(x)
    {
        var pos = x-ruler.offset().left;
        return pos/ruler.width()*viewTotalLen;
    }

    function rulerDn(e)
    {
        var p = calcTime(e.pageX);
        console.log( 'rulerDn', e.pageX, p );
        video.currentTime = calcTime(e.pageX);
        console.log( 'rulerDn', e.pageX, p, video, video.currentTime );
    }

    function rulerUp(e)
    {

    }


    function addTrack() {
        // if( questionMode ) return questionOptions(0);
        // function opt( name, val ){ return $('<OPTION value="'+val+'">').html(name); }
        // console.log( 'addTrack');

        // var content = $('<DIV>');

        // var chooseCategory = $('<DIV>').addClass('form-group').append($('<label for="selcategory">Select Category:</label>'));
        // var category = $('<SELECT id="selcategory">').addClass('form-control');
        // for( var c in tagData.categories )
        //     category.append(opt(c,c));

        // var chooseTag = $('<DIV>').addClass('form-group').append($('<label for="seltag">Select Tag:</label>'));
        // var tag = $('<SELECT id="seltag">').addClass('form-control');
        // function selCateg(c)
        // {
        //     console.log( 'selCateg', c );
        //     tag.html('');
        //     tagData.categories[c].forEach( function(t)
        //     {
        //         tag.append(opt(t,t));
        //     });
        // }

        // function add()
        // {
        //     var tname = category.val() + txtSeparator + tag.val();
        //     console.log( 'add', category.val(), tag.val() );
        //     if( tname in trackList )
        //     {
        //         return modalWait( function()
        //         {
        //             modal( 'Add New Annotation Track',
        //             "This track: <b>"+tname+"</b> is already added.<br>You can add new annotations to the same track." );
        //         });
        //     }
        //     setTrack( tname );
        // }
        // category.on('change',function(){ selCateg($(this).val())});
        // selCateg(category.val());


        // chooseCategory.append(category);
        // chooseTag.append(tag);
        // content.append(chooseCategory,chooseTag);
        // modal( 'Add New Annotation Track', content, 'Add', add );
    }

	function newTrackId()
	{
		var max = window.maxTrackId || 0;
		window.maxTrackId = ++max;
		return window.maxTrackId;
	}

	function getQSet( trackId )
	{
		if( !descriptor.questionnaireSettings ) descriptor.questionnaireSettings = {};
		if( !descriptor.questionnaireSettings[trackId] ) descriptor.questionnaireSettings[trackId] = {}
		// console.log( 'getQSet', trackId, descriptor.questionnaireSettings[trackId] )
		return descriptor.questionnaireSettings[trackId]
	}
	function setQSet( trackId, val )
	{
		if( !descriptor.questionnaireSettings ) descriptor.questionnaireSettings = {};
		if( !descriptor.questionnaireSettings[trackId] ) descriptor.questionnaireSettings[trackId] = {}
		descriptor.questionnaireSettings[trackId] = val;
		return val;
	}

	function questionOptions( trackId )
	{
		var addNew = trackId == 0;
		if( addNew ) trackId = newTrackId();
		// alert( trackId );
		function opt( name, val ){ return $('<OPTION value="'+val+'">').html(name); }
		console.log( 'addTrack');

		var ques = descriptor.questionnaire[currentQuestion];
		var settings = clone(getQSet(trackId));
		var origSettings = clone(settings);
		var content = $('<DIV>');

		// radioList( div, iattrs, opt, title )
		if( ques.attributes && ques.attributes.length )
		{
			ques.attributes.forEach( a => {
				var att = a.label;
				radioList( content, a, settings );
			});
		}
		var desc = $('<div class="question-field field"><div class="err"></div><span>Description:</span>').prop('field','description').append( $('<TEXTAREA id="evidence-desc" class="inote-text mt-2"></div>').prop('placeholder',ques.description).val(settings.description).on('change',function(){settings.description = $(this).val().trim()}) );
		content.append(desc);

		if( ques.userNote)
		{
			var note = $('<div class="question-field field" field><div class="err"></div><span>Optional Notes:</span>').prop('field','note').append( $('<TEXTAREA id="evidence-note"  class="inote-text mt-2"></div>').prop('placeholder','optional notes').val(settings.note).on('change',function(){settings.note = $(this).val().trim()}) );
			content.append(note);
		}

		function error( label, msg )
		{
			var fields = content.find('.field');
			for( var i = 0 ; i < fields.length ; i++ )
			{
				var f = fields[i];
				console.log( 'EACH', i, $(f).prop('field'), 'label', label, $(f).prop('field') == label );
				if( $(f).prop('field') == label )
				{

					$(f).find('.err').html(msg);
					return false;
				}
			}
			return true;
		}

		function validate()
		{
			if( ques.attributes && ques.attributes.length )
			{
				for( var i = 0 ; i < ques.attributes.length ; i++ )
				{
					var a = ques.attributes[i]
					if( !settings[a.label] ) return error( 'radio-'+a.label, 'Please select an option')
				}
			}
			if( !settings.description )
			{
				$('#evidence-desc').focus();
				return error( 'description', 'Please add the description' );
			}
			return true;
		}

		function add( ev )
		{
			if( !validate() ) return true; // true cancels modal hiding
			setQSet( trackId, settings );
			setTrack( trackId );
			report()
		}
		function edit( ev )
		{
			if( !validate() ) return true; // true cancels modal hiding
			setQSet( trackId, settings );
			setTrack( trackId );
			report()
		}
		if( addNew )
		{
			// if( descriptor.questionnaireAnnotations[currentQuestion].false )
				modal( ques.button, content, 'Add', add );
			// else
			// 	modal( 'Not false answer', "You can't annotate evidences if the anwer is not checked as <b>false</b>" );
		}
		else
			modal( 'Edit', content, 'Save', edit );
	}


    var lastReportSelect = null;
    var startSelect = null;
    var endSelect = null;
    function report() {
        // console.log( 'report', reportObj, trackList )
        // if( !reportObj ) return;
        // tagData.streams = {};
        // var ranges = [];
        // for( var t in trackList )
        // {
        //     trackList[t].forEach(function(r,idx)
        //     {
        //         var id = simplify(t + txtSeparator + idx);
        //         var c = t.split(txtSeparator)[0];
        // 		var name = t;
        // 		if( questionMode ) name = getQSet(t).description;
        // 		var robj = {start:r[0],end:r[1],id:id,tag:name,category:c};
        // 		if( r[2] ) robj.text = r[2]
        //         ranges.push(robj);
        //     });
        // }
        // window.ranges = allRanges = ranges;
        // var sfunc = function(a,b)
        // {
        //     if( a.category == b.category )
        //     {
        //         if( a.start == b.start ) return a.end > b.end ? 1 : -1;
        //         return a.start > b.start ? 1 : -1;
        //     }
        //     else return a.category > b.category ? 1 : -1;
        // };

        // if( questionMode ) sfunc = function(a,b)
        // {
        // 	if( a.start == b.start ) return a.end > b.end ? 1 : -1;
        // 	return a.start > b.start ? 1 : -1;
        // }
        // ranges.sort(sfunc);

        // console.log( 'ranges', ranges )

        // reportObj.html('');
        // if( !ranges.length ) return reportObj.html('<span class="tag-panel-empty">(no annotations)</span>');
        // var tab = $('<TABLE>').addClass('reporttable');
        // var thead = $('<THEAD>');
        // var tr = $('<TR>');
        // tr.append($('<TH>').html('Start'));
        // tr.append($('<TH>').html('-'));
        // tr.append($('<TH>').html('End'));
        // tr.append($('<TH>').html(transcriptionMode ? 'Text':'Tag'));
        // thead.append(tr);
        // tab.append(thead);
        // var streams = {};
        // ranges.forEach(function(r)
        // {
        // 	if( !questionMode )
        // 	{
        // 		var tmp = r.tag.split(txtSeparator);
        // 		var category = tmp[0];
        // 		var tag = tmp[1];
        // 		if( !streams[category] ) streams[category] = [];
        // 		var sobj = {id:tag,start:r.start,end:r.end};
        // 		if( transcriptionMode ) sobj.text = r.text;
        // 		streams[category].push(sobj);
        // 	}
        //     var tr = $('<TR>').prop('id','report'+r.id).addClass('reporttr');
        // 	if( transcriptionMode ) tr.prop('text',r.text);
        //     tr.append($('<TD>').prop('id','report'+r.id+'_0').html(ftime(r.start,1)).dblclick(rstart));
        //     tr.append($('<TD>').html('-'));
        //     tr.append($('<TD>').prop('id','report'+r.id+'_1').html(ftime(r.end,1)).dblclick(rend));
        //     tr.append($('<TD>').html(transcriptionMode ? r.text : r.tag));
        //     tab.append(tr);
        // 	var clickTid = null;
        // 	tr.click(function()
        // 	{
        // 		console.log( 'repor click', r.id );
        // 		reportSelect( r.id );
        // 		if( !clickTid )
        // 		{
        // 			clickTid = setTimeout( function(){
        // 				console.log( 'PLAY')
        // 				playRange($('#'+r.id));
        // 				clickTid = null;
        // 			}, 300 );
        // 		}
        // 		console.log( 'play', clickTid )
        // 	})
        // 	tr.dblclick( function(){
        // 		console.log( 'double', r.id )
        // 		clearTimeout( clickTid );
        // 		clickTid = null;
        // 		reportSelect( r.id );
        // 		transcriptionText( r.id )
        // 	});

        // 	function rstart(ev)
        // 	{
        // 		startSelect = r;
        // 		reportSelect( r.id );
        // 		console.log( 'rstart', r.id )
        // 		clearTimeout( clickTid );
        // 		clickTid = null;
        // 		$('.time-sel').removeClass('time-sel')
        // 		$(this).addClass('time-sel')
        // 		videoPause();
        // 		video.currentTime = r.start;
        // 		selectRange( $('#'+r.id))
        // 		return false;
        // 	}

        // 	function rend(ev)
        // 	{
        // 		endSelect = r;
        // 		console.log( 'rend')
        // 		reportSelect( r.id );
        // 		clearTimeout( clickTid );
        // 		clickTid = null;
        // 		$('.time-sel').removeClass('time-sel')
        // 		$(this).addClass('time-sel')
        // 		videoPause();
        // 		video.currentTime = r.end;
        // 		selectRange( $('#'+r.id))
        // 		return false;
        // 	}
        // });
        // reportUnselect();
        // tagData.streams = streams;
        // reportObj.html('').append(tab);
        // // console.log( ranges );
    }

    function reportSelect(id) {
        // if( id == lastReportSelect ) return;
        // startSelect = null;
        // endSelect = null;
        // $('.time-sel').removeClass('time-sel')
        // lastReportSelect = id;
        // // console.log( 'reportSelect', id )
        // $('.reporttr').removeClass('reportselected');
        // $('#report'+id).addClass('reportselected');
        // var top = $('#report'+id).position().top;
        // $('#reportpanel').scrollTop( top-$('#reportpanel').height()/2 );
        // var text = $('#report'+id).prop('text');
        // if( text ) $('#subtitles').html('<span>'+text+'</span>');
    }

    function reportUnselect() {
        // $('#subtitles').html('')
        // $('.reporttr').removeClass('reportselected');
        // lastReportSelect = null;
    }

    function fixTrack(tlist, rangeObj) {
        // if( !isarray(tlist)) tlist = [tlist];
        // tlist.forEach( function(track)
        // {
        //     var otrack = track;
        //     track = $(track);
        //     var tname = track.prop('name');
        //     var ranges = trackList[tname];
        // 	if( !ranges ) return;
        //     // console.log( 'fixtrack', otrack, track, 'tname', tname, 'trackList', trackList, 'ranges', ranges );
        // 	function rsort(a,b)
        // 	{
        // 		if( a[0] == b[0] ) return a[1] > b[1] ? 1 : -1;
        // 		return a[0] > b[0] ? 1 : -1;
        // 	}
        //     var optimized = false;
        // 	if( transcriptionMode )
        // 	{
        // 		console.log( 'fixTrackkkkkk', rangeObj )
        // 		if( rangeObj )
        // 		{
        // 			var targetIdx = rangeObj.split('_').pop()*1;
        // 			console.log( 'fixTrack', rangeObj, targetIdx )
        // 			var rt = ranges[targetIdx];
        // 			var spliceList = [];
        // 			for( var [i,r] of ranges.entries() )
        // 			{
        // 				if( i == targetIdx ) continue;
        // 				if( r[0] < rt[0] && r[1] > rt[1] ) // if target range is inside current range
        // 				{
        // 					var nr = clone(r);
        // 					r[1] = rt[0];
        // 					nr[0] = rt[1];
        // 					ranges.push(nr);
        // 				}
        // 				else if( r[0] > rt[0] && r[1] < rt[1] )
        // 				{
        // 					spliceList.unshift(i);
        // 				}
        // 				else if( r[0] > rt[0] && r[0] < rt[1] )
        // 				{
        // 					r[0] = rt[1];
        // 				}
        // 				else if( r[1] > rt[0] && r[1] < rt[1] )
        // 				{
        // 					r[1] = rt[0];
        // 				}
        // 				console.log( r, i, rangeObj )
        // 			}
        // 			spliceList.forEach( s => ranges.splice(s,1) );
        // 			ranges.sort(rsort);
        // 		}
        // 	}
        //     else {
        // 		ranges.sort(rsort);
        // 		do {
        // 			var again = false;
        // 			for( var i = 0 ; i < ranges.length-1 ; i++ )
        // 			{
        // 				if( ranges[i][1] == ranges[i+1][0] ) // if ranges are glued, make it one
        // 				{
        // 					ranges[i][1] = ranges[i+1][1];
        // 					ranges.splice(i+1,1);
        // 					optimized = again = 1;
        // 					break;
        // 				}
        // 				else if( ranges[i+1][0] < ranges[i][1] && ranges[i+1][1] < ranges[i][1] ) // ranges are nested delete the nested one
        // 				{
        // 					ranges.splice(i+1,1);
        // 					optimized = again = 1;
        // 					break;
        // 				}
        // 				else if( ranges[i+1][0] < ranges[i][1] && ranges[i+1][1] >= ranges[i][1]) // ranges are overlaped
        // 				{
        // 					ranges[i][1] = ranges[i+1][1];
        // 					ranges.splice(i+1,1);
        // 					optimized = again = 1;
        // 					break;
        // 				}
        // 			}
        // 		} while( again );
        // 	}

        //     // console.log( 'fixTrack', tname, JSON.stringify(ranges) );
        // });
        // // if( optimized )
        // drawTracks();
    }

    function segmentationEdit(id) {

    }

    function transcriptionText(id) {
        if (!id) return;
        videoPause();

        var i = id.split('_').pop() * 1;
        var r = trackList[currentTrackName][i]
        console.log('transcriptionText', id, r)
        video.currentTime = r[1]
        var text = r[2] || '';
        myAlert('Transcription Text', '', 'Set Text', function () {
            var text = $('#tag-text').val().trim();
            if (!text) {
                $('.modal-body').find('.err').html('Enter the transcription text');
                return true;
            }
            trackList[currentTrackName][i][2] = text;
            changed();
            fixTrack(selectedTrack, id);
            recordingRanges = [];
            reportSelect(id);
        }, 'Cancel', function () {
            if (text == '') trackList[currentTrackName].splice(i, 1);
            fixTrack(selectedTrack);
            recordingRanges = [];
        })
        var desc = $('<div class="question-field field"><div class="err"></div>').append($('<TEXTAREA id="tag-text" class="inote-text mt-2"></div>').prop('placeholder', 'Enter transcription text').val(text));
        $('.modal-body').html('').append(desc);
        setTimeout(function () {

            // $('#tag-text').select()
        }, 500)
    }
    function endRecording() {
        // isRecording = false;
        // crec.prop('rec',0);
        // crec.removeClass('trackrecording');
        // crec.html('Begin Recording')
        // if( !selectedTrack ) return;
        // videoPause();
        // if( transcriptionMode )
        // {
        // 	return transcriptionText(recordingRanges[0]);
        // }
        // fixTrack(selectedTrack, recordingRanges[0]);
        // recordingRanges = [];
        // changed();
    }

    function beginRecording() {
        // if( !selectedTrack )
        // {
        //     if( transcriptionMode ) setTrack('Transcription');
        //     else return modal( 'Record Annotation', 'Select or add a track first' );
        // } 
        // crec.prop('rec',1);
        // crec.addClass('trackrecording');
        // crec.html('Stop Recording')
        // selectedTrack.forEach( function(track)
        // {
        //     track = $(track);
        //     var tname = track.prop('name');
        //     console.log( tname, trackList[tname] );
        //     var idx = simplify(tname+txtSeparator+trackList[tname].length);
        //     var range = [video.currentTime, video.currentTime+rangeMargin];
        //     trackList[tname].push(range);
        //     var r = addRange( track, range, idx );
        //     r.addClass('trackrangerecording');
        //     recordingRanges.push(r.prop('id'));
        // });
        // isRecording = recordingRanges;
        // playTo = -1;
        // videoPlay();
    }

    function recording() {
        // if( isRecording )
        //     endRecording()
        // else
        //     beginRecording()
    }

    function zoomUpdate() {
        // czoomTxt.html(viewZoom.toFixed(0)+'X');
        // view( viewPos, viewZoom );
    }

    function zoomIn() {
        // if( viewZoom >= 256 ) return;
        // viewZoom *= 2;
        // console.log( 'zoomIn', viewZoom );
        // zoomUpdate();
    }

    function zoomOut() {
        // if( viewZoom == 1 ) return;
        // viewZoom /= 2;
        // // console.log( 'zoomOut', viewZoom );
        // zoomUpdate();
    }

    function zoomSet(v) {
        // if( v >= 256 || v <= 1 ) return;
        // viewZoom = v;
        // zoomUpdate();
    }


    function simplify(s) {
        return s.replace(/[^0-9a-z]/ig, '_');
    }

    function playback(t1, t2, callback) {
        // videoPos(t1);
        // playTo = t2;
        // playToCallback = callback;
        // videoPlay();
    }

    function stopplayback() {
        // video.pause();
        // videoPos(playTo);
        // playTo = -1;
        // if( playToCallback )
        // {
        // 	playToCallback();
        // 	playToCallback = null;
        // 	return;
        // }
        // $('.trackrange').removeClass('trackrangeselected');
    }

    function calcPos(t) {
        return t / viewTotalLen * ruler.width();
    }

    var trackList = {};
    window.__trackList = trackList;

    function deleteRange(range) {
        // console.log( 'deleteRange', range )
        // var tname = range.prop('trackname');
        // var range = range.prop('range');
        // var idx = trackList[tname].indexOf(range);
        // if( idx >= 0 ) trackList[tname].splice(idx,1);
        // console.log( 'deleterange', idx, trackList );
        // selectedRange = null;
        // selectedRangeId = -1;
        // changed();
        // drawTracks();
        // endRecording();
    }

    function moveRange(range, track) {
        // var tname = range.prop('trackname');
        // var r = range.prop('range');
        // var rid = range.prop('idx');
        // var newTrack = track.prop('name');
        // var idx = trackList[tname].indexOf(r);
        // if( idx >= 0 ) trackList[tname].splice(idx,1);
        // range.remove();
        // rid = simplify(newTrack + '_' + 1000 );
        // trackList[newTrack].push(r);
        // track.append(range);
        // range.prop('id',rid);
        // range.prop('idx',rid);
        // range.prop('trackname',newTrack);
        // range.prop('moved',true);
        // console.log( 'orig', tname, r, rid, track.prop('name'), idx );
    }

    function addRange(track, range, idx) {
        // var r = $('<div>').addClass('trackrange');
        // var tw = ruler.width();
        // var pl = calcPos(range[0]);
        // var pr = calcPos(range[1]);
        // var w = pr-pl;
        // r.css({left:px(pl),width:px(w)});
        // var ml = $('<div>').addClass('trackrangemove trackrangemoveleft').css({left:px(-5)});
        // var mr = $('<div>').addClass('trackrangemove trackrangemoveright').css({right:px(-5)});
        // ml.on('mousedown',rangeMoveLeft);
        // mr.on('mousedown',rangeMoveRight);
        // r.prop('id',idx);
        // r.append( ml, mr );
        // r.prop('idx',idx).prop('track',track).prop('trackname',track.prop('name'));
        // r.prop('range', range);
        // if( idx == selectedRangeId )
        // {
        //     r.addClass('trackrangeselected');
        //     selectedRange = r;
        // }
        // // console.log( 'ADDRANGE', isRecording, idx, recordingRanges );
        // if( isRecording && recordingRanges.indexOf(idx) >= 0 ) r.addClass('trackrangerecording');
        // r.click(function()
        // {
        //     playRange($(this));
        //     return false;
        // })
        // r.on('mousedown',rangeDragStart);
        // track.append(r);
        // return r;
    }

    var rangeDragging = null;
    function rangeDragStart() {
        // // console.log( 'dragstart')
        // rangeDragging = $(this);
        // $(document).on('mouseup',rangeDragEnd);
    }

    function rangeDragCheck() {
        // if( !rangeDragging ) return;
        // // console.log( 'dragcheck', rangeDragging, $(this).prop('name'));
        // moveRange(rangeDragging,$(this));
    }

    function rangeDragEnd() {
        // $(document).unbind('mouseup');
        // if( !rangeDragging.prop('moved'))
        // {
        //     playRange( rangeDragging );
        //     selectRange( rangeDragging );
        //     rangeDragging = null;
        //     return false;
        // }
        // var tname = rangeDragging.prop('trackname');
        // var tid = 'track_'+simplify(tname);
        // fixTrack($('#'+tid), 'rangeDragging' );
        // rangeDragging = null;
    }

    function playRange(rangeObj) {
        // reportSelect( rangeObj.prop('id') );
        // var idx = rangeObj.prop('idx');
        // selectRange(rangeObj);
        // var range = rangeObj.prop('range');
        // playback( range[0], range[1], function(){
        // 	setTimeout( function(){
        // 		video.currentTime = range[1];
        // 		reportSelect( rangeObj.prop('id') );
        // 	},1 );
        // } )
    }

    function deleteTrack(tlist) {
        // if( transcriptionMode ) return;
        // tlist.forEach( function(track)
        // {
        //     track = $(track);
        //     var tname = track.prop('name');
        //     if( trackList[tname] && trackList[tname].length )
        //     return modal( 'Delete Track', "Track is not empty. Delete all annotations before deleting a track.")
        //     delete trackList[tname];
        //     track.remove();
        //     console.log( 'delete', tname, trackList);
        // });
        // unselectAll();
        // drawTracks();
    }

    function setTrack(tname, range, idx) {
        // if( transcriptionMode ) tname = currentTrackName;
        // var tid = 'track_'+simplify(tname.toString());
        // var labid = 'label_' + tid;
        // // console.log( 'tid', tid );
        // if( questionMode ) var name = getQSet(tname).description;
        // else var name = tname;
        // if( !$('#'+tid).length )
        // {
        //     var track = $('<div>').prop('id',tid).addClass('track').append($('<div>').prop('id',labid).addClass('tracklabel').html(name));
        //     track.prop('name',tname);
        //     track.click(selectTrackClick);
        //     tracks.append(track);
        // }
        // else var track = $('#'+tid);
        // track.on('mouseenter',rangeDragCheck);
        // $('#'+labid).html(name);
        // // r.html(dt);
        // if( range ) addRange( track, range, idx );
        // else if( !(tname in trackList ) ) trackList[tname] = [];
        // $('.trackempty').remove();
        // selectTrack(track);
    }

    function unselectAll() {
        // $('.trackrange').removeClass('trackrangeselected');
        // $('.track').removeClass('trackselected');
        // selectedTrack = null;
        // selectedRangeId = -1;
        // selectedRange = null;
    }

    var recentSelect = false;
    function selectTrackClick() {
        // var track = this;
        // if( questionMode )
        // {
        // 	if( recentSelect ) return doubleClickTrack(track);
        // 	recentSelect = true;
        // 	setTimeout( function(){recentSelect=false;}, 1000 )
        // }
        // console.log( 'TRACK', track )
        // if( isRecording ) endRecording();
        // // if( selectedTrack && selectedTrack.indexOf(track) >= 0 ) return unselectTrack(track);
        // if( !window.shiftKey ) unselectAll();
        // selectTrack(track);
    }

    function unselectTrack(track) {
        // if( isarray(track)) track = track[0];
        // if( !selectedTrack ) return;
        // var idx = selectedTrack.indexOf(track);
        // if( idx >= 0 ) selectedTrack.splice(idx,1);
        // $(track).removeClass('trackselected');
    }

    function selectTrack(track) {
        // if( isarray(track)) track = track[0];
        // console.log( 'SELECTTRACK', track );
        // if( window.shiftKey && selectedTrack && selectedTrack.indexOf(track) == -1 ) selectedTrack.push(track);
        // else selectedTrack = [track];
        // $('.track').removeClass('trackselected');
        // selectedTrack.forEach(function(t){$(t).addClass('trackselected')});
        // // console.log( 'ssss', selectedTrack )
    }

    function doubleClickTrack(track) {
        // 	questionOptions($(track).prop('name'))
        // 	console.log( 'double', $(track).prop('name') );
    }


    function updateRange(obj, r) {
        // var pl = calcPos(r[0]);
        // var w = calcPos(r[1])-pl;
        // obj.css({left:px(pl),width:px(w)});
    }

    function selectRange(r) {
        // // alert(1)
        // if( isRecording ) endRecording();
        // var idx = r.prop('idx');
        // selectedRange = r;
        // selectedRangeId = idx;
        // selectTrack(r.prop('track')[0]);
        // $('.trackrange').removeClass('trackrangeselected');
        // r.addClass('trackrangeselected');
    }

    if (!tagData.categories) tagData.categories = {};

    function loadTracks(streams) {
        // if( !streams ) streams = {};
        // trackList = {};
        // $('.tracklist').html('')
        // console.log( 'loadtracks', streams )
        // for( var k in streams )
        // {
        // 	var st = clone(streams[k]);
        // 	var id = newTrackId();
        // 	var ranges = st.ranges;
        // 	delete st.ranges;
        // 	trackList[id] = ranges;
        // 	// console.log( 'new track', id, st, ranges )
        // 	setQSet( id, st );
        // }
        // drawTracks();
        // report();
    }

    function saveTracks() {
        // var res = [];
        // for( var t in trackList )
        // {
        // 	var st = clone(getQSet(t));
        // 	st.ranges = trackList[t];
        // 	res.push( st );
        // }
        // console.log( 'SAVETRACKS', res );
        // return res;
    }

    function clearTracks() {
        // trackList = {};
    }

    this.videoCheckInit = videoCheckInit;
	this.loadTracks = loadTracks;
	this.saveTracks = saveTracks;
	this.clearTracks = clearTracks;
	this.zoomSet = zoomSet;
	this.setTrack = setTrack;
    // console.log( 'tagData', tagData.streams );

	function parseAWSStreams( annotations )
	{
        var timeOffset = 0;
		if( !annotations.streams || !annotations.streams.jobName ) return;
		var base = annotations.streams.results.items;
		// console.log( base )
		var tags = [];
		annotations.streams = {};
		annotations.streams[currentTrackName] = tags;
		var tag = {text:[],confidence:1};
        tag.confidence = 1;
		function addTag()
		{
            console.log( 'addTag', tag )
			tag.text = tag.text.join('');
			if( tag.text ) tags.push( tag );
			tag = {text:[],confidence:1};
		}
        var lastBase = null;
		for( var b of base )
		{
			var bstart = b.start_time*1+timeOffset;
			if( !('start' in tag) ) tag.start = bstart;
			// console.log( tag.end && bstart-tag.end )
			// if( tag.end && bstart-tag.end > 0.2 ) addTag();
			if( b.end_time ) tag.end = b.end_time*1+timeOffset;
			// console.log( b.alternatives[0].content, b.type )
			if( b.type == 'punctuation')
			{
				tag.text.push(b.alternatives[0].content);

				// if( tag.end-tag.start > 1 )
				addTag()
			}
			else {
				if( tag.text.length ) tag.text.push(' ');
				tag.text.push(b.alternatives[0].content)
                tag.confidence = Math.min(tag.confidence, b.alternatives[0].confidence)
				// if( tag.text.length > 15 ) addTag();
			}
            lastBase = b;
		}
		addTag();
        var ltag = null;
        var splice = [];
        tags.forEach( (t,i) => {
            if( ltag && t.text.match(/^[A-Z]\./) ) {
                ltag.text += ' ' + t.text;
                splice.unshift(i);
                return;
            }
            ltag = t;
        });
        for( var i of splice ) tags.splice(i,1);
		console.log( 'parse', annotations.streams )
	}
	if( transcriptionMode ) parseAWSStreams(tagData);

    // for( var c in tagData.streams )
    // {
    //     if( !(c in tagData.categories) ) tagData.categories[c] = [];
    //     var st = tagData.streams[c];
    //     st.forEach( function(s)
    //     {
    //         var key = c+txtSeparator+s.id;
	// 		if( transcriptionMode || descriptor.hierarchy ) key = c;
    //         if( !(key in trackList) ) trackList[key] = [];
    //         var range = [s.start,s.end,s.text]
    //         trackList[key].push(range);
    //     });
    // }
	window.trackList = trackList;
    // console.log( trackList );

    function rangeMoveEnd()
    {
        // console.log( 'rangeMoveEnd')
        // $(document).unbind('mousemove');
        // $(document).unbind('mouseup');
        // video.pause();
        // fixTrack(selectedTrack, (rangeMoving && rangeMoving.prop('id')) || null );
        // changed();
        // return false;
    }

    var rangeMoving = false;
    var rangeSide = 0;
    var rangeMoveMin = 0;
    var rangeMoveMax = 99999999;
    var rangeMargin = 0.033;
    function rangeMoveRight()
    {
        // if( isRecording ) endRecording();
        // console.log( 'rangeMoveRight')
        // rangeSide = 1;
        // var rangeObj = $(this).parent()
		// rangeMoving = rangeObj;
        // selectRange(rangeObj);
        // var range = rangeObj.prop('range');
        // var tname = rangeObj.prop('trackname');
        // var rangeList = trackList[tname];
        // var ridx = rangeList.indexOf( range );
        // if( ridx == rangeList.length-1 || transcriptionMode ) rangeMoveMax = video.duration;
        // else rangeMoveMax = rangeList[ridx+1][0];
        // rangeMoveMin = range[0]+rangeMargin;
        // console.log( 'right', rangeMoveMin, rangeMoveMax );

        // $(document).on('mousemove', rangeMove );
        // $(document).on('mouseup', rangeMoveEnd );
        // return false;
    }
    function rangeMoveLeft()
    {
        // if( isRecording ) endRecording();
        // console.log( 'rangeMoveLeft')
        // rangeSide = 0;
        // var rangeObj = $(this).parent()
		// rangeMoving = rangeObj;
        // selectRange(rangeObj);
        // var range = rangeObj.prop('range');
        // var tname = rangeObj.prop('trackname');
        // var rangeList = trackList[tname];
        // var ridx = rangeList.indexOf( range );
        // if( ridx == 0 || transcriptionMode ) rangeMoveMin = 0;
        // else rangeMoveMin = rangeList[ridx-1][1];
		// if( transcriptionMode ) rangeMoveMax = video.duration;
        // else rangeMoveMax = range[1]-rangeMargin;
        // console.log( 'left', rangeMoveMin, rangeMoveMax );

        // $(document).on('mousemove', rangeMove );
        // $(document).on('mouseup', rangeMoveEnd );
        // return false;
    }
    function rangeMove(e)
    {
        // var t = calcTime(e.pageX);
        // if( t < rangeMoveMin ) t = rangeMoveMin;
        // else if( t > rangeMoveMax ) t = rangeMoveMax;
        // var r = selectedRange.prop('range');
        // r[rangeSide] = t;
        // updateRange(selectedRange, r);
        // // console.log( 'rangeMove', selectedRange  );
    }

    function drawTracks()
    {
        // if( viewZoom == 0 ) return;
        // var dt = viewTotalLen/viewZoom;
        // var txtdiv = Math.floor(contentWidth/120);
        // var twid = contentWidth*viewZoom;
        // // console.log( 'drawTracks', contentWidth, dt, 'txtdiv', txtdiv );
        // function drawRuler()
        // {
        //     ruler.html('');
        //     var tviews = [
        //         [ 1800, 300 ], // 30 minutos, divisao 5 min
        //         [ 600, 60 ], // 10 minutos, divisao 1 min
        //         [ 300, 60 ], // 5 minutos, divisao 30s
        //         [ 120, 10 ], // 2 minutos, divisao 10s
        //         [ 60, 5 ], // 1 minutos, divisao 5s
        //         [ 30, 5 ], // 30 segundos, divisao 2s
        //         [ 10, 1 ], // 10 segundos, divisao 1s
        //         [ 5, 0.5 ], // 5 segundos, divisao 0.5s
        //         [ 2, 0.2 ], // 2 segundos, divisao 0.2s
        //         [ 1, 0.1 ], // 1 segundo, divisao 0.1s
        //     ];
        //     for( var i = 0 ; i < tviews.length ; i++ )
        //     {
        //         // console.log( 'dt', dt, tviews[i], dt/tviews[i][0] )
        //         if( dt/tviews[i][0] >= txtdiv ) break;
        //     }
        //     if( i == tviews.length ) i--;
        //     var rulerView = i;
        //     ruler.css({width:px(twid)});
        //     var rmark = tviews[rulerView][1];
        //     var rtxt = tviews[rulerView][0];
        //     var markdiv = Math.floor(viewTotalLen/rmark);
        //     var rwid = twid*(markdiv/(viewTotalLen/rmark))
        //     var markw = rwid/markdiv;
        //     for( var i = 0 ; i <= markdiv ; i++ )
        //         ruler.append($('<div>').addClass('trackrulermark').css({left:px(i*markw)}));
        //     var labdiv =  Math.floor(viewTotalLen/rtxt);
        //     var labw = markw*(rtxt/rmark);
        //     for( var i = 0 ; i <= labdiv ; i++ )
        //         ruler.append($('<div>').addClass('trackrulerlabel').css({left:px(i*labw)}).html(ftime(i*rtxt)));
        //     // console.log( 'rulerView', rulerView, tviews[rulerView], labdiv );
        // }
        // drawRuler();
        // $('.trackrange').remove();
        // for( var c in trackList )
        // {
        //     trackList[c].forEach( function(r,idx)
        //     {
        //         setTrack(c, r, simplify(c+txtSeparator+idx) );
        //     })
        // }
        // $('.trackempty').remove();
        // if( !Object.keys(trackList).length ) tracks.html('').append($('<div>').html('no tracks').addClass('trackempty').css({lineHeight:px(tracks.height())}));

        // report();
    }
	// console.log( 'trackList', trackList );
	if( transcriptionMode && !Object.keys(trackList).length )
		setTrack(currentTrackName)
    // drawRuler();
    // for( var )
    videoCheckInit();
    return this;
}

function showVersion(s)
{
	descriptor.version = s;
	$('#version').remove();
	$('#t_right').prepend(
		$('<span>')
		.addClass('version')
		.prop('id','version')
		.html('Version: '+s)
	);
}

function checkBox( div, label, checked, callback )
{
	function ck( bool, label )
	{
		var rck = bool ? 'fa-check-square-o' : 'fa-square-o';
		return '<i class="fa ' + rck + ' check-box-icon"></i> ' + label;
	}
	var cbox = $('<div>').prop('field', 'check-'+label ).addClass('radio-list').addClass('field');
	cbox.html('<div class="err"></div>');

	var sopt = $('<span>').addClass('radio-list-option').html( ck( checked, label) ).prop('checked',checked).on('click', function(){
		var checked = $(this).prop('checked') || false;
		checked = !checked;
		$(this).prop('checked', checked)
		$(this).html(ck( checked, label));
		if( callback ) callback(checked);
	})
	cbox.append( sopt );
	div.html('').append(cbox)
	console.log( 'checkbox', label, checked );
}


function radioList( div, iattrs, opt )
{
	var radio = $('<div>').prop('field', 'radio-'+iattrs.label ).addClass('radio-list').addClass('field');
	console.log( 'radioList', iattrs, opt );
	function ck( bool )
	{
		var rck = bool ? 'fa-check-circle-o' : 'fa-circle-o';
		return '<i class="fa ' + rck + '"></i>';
	}
	if( !opt ) opt = {};
	var optid = iattrs.label;
	function options()
	{
		radio.html('<div class="err"></div>');
		if( !iattrs.noLabel ) radio.append('<span class="radio-list-title">' + iattrs.label + ':<span>');
		iattrs.options.forEach( o => {
			var sopt = $('<span>').addClass('radio-list-option').html( ck( o == opt[optid]) + ' ' + o ).prop('optid',o).on('click', function(){
				opt[optid] = $(this).prop('optid');
				console.log( 'optid', optid, 'v', opt);
				options();
			})
			radio.append( sopt );
		})
	}
	options();
	div.append( radio );
}


function listAttributes( div, iattrs, attributes, title )
{
    div.html('');
    div.addClass('text-attrs');
    // console.log( 'iattrs', iattrs )
    if( iattrs )
    {
        var choose = $('<DIV>');
		// choose.append($('<DIV>').addClass('cchoosetitle').addClass('cchooselabel').html('<h5>'+title+'</h5>'));
		choose.append($('<DIV>').addClass('cchoosetitle').addClass('cchooselabel'));
        choose.css({width:px(div.width())})
        div.append( choose );

        iattrs.forEach( function(a){
            a.optional = bool(a.optional);
            a.allowNew = bool(a.allowNew);
            if( !( a.label in attributes) && !a.optional ) attributes[a.label] = null;
            var label = a.label;
            // if( !a.optional ) label = '*'+label;
            var aline = $('<div>').html('<div class="doc-attributes">'+label+'</div>');
            var select = $('<select class="mmdb-select mmd-form iselect">');
            select.prop('id','select'+label);
            aline.append(select);
            if( !a.options ) a.options = ["no", "yes"];
			var placeholder = a.placeholder || '(select)';
			select.append( $('<option>').prop('value','').html( placeholder ));
            var opts = {};
			if( attributes[a.label] && a.options.indexOf(attributes[a.label]) == -1 )
				a.options.push(attributes[a.label])
            a.options.forEach(function(aopt,idx){
                opts[aopt] = 1;
                select.append( $('<option>').prop('value',aopt).html( aopt ));
            });
			// console.log('ATTR', attributes[a.label], a.options );
            if( a.allowNew )
            {
                select.append( $('<option>').prop('value','_new').html( '(Add new '+ a.label + ')' ));
            }
            select.val(attributes[a.label])
            select.on('change', function(){
                // selectStyle(select);
                val = select.val();
                if( val == '' ) val = null;
                attributes[a.label] = val;
                if( val != '_new' ) text.hide();
                else
                {
                    text.show();
                    text.focus();
                }
				changed();
            });
            var text = $('<INPUT TYPE="text">').prop('id','selectText'+a.label).addClass('iselect-text').hide();
            text.on('keyup',function(ev)
            {
                if( ev.keyCode == 13 )
                {
					textSave();
                }
            });
			text.on('change',textSave)
			function textSave()
			{
				val = text.val().trim();
				if( val == '' ) return myAlert( 'Value Required', 'Please select the new value for attribute "'+ a.label +'"' );
				text.hide();
				if( !(val in opts) )
				{
					a.options.push( val );
				}
				attributes[a.label] = val;
				listAttributes( div, iattrs, attributes );
			}
            aline.append(text);
            choose.append(aline);
        });
    }
    // div.append( $('<br><h5>Aditional Notes</h5>') );
	// var addNotes = $('<TEXTAREA>').addClass('inote-text');
	var addNotes = descriptor.reviewMode ? $('#reviewer_notes') : $('#annotator_notes');
    addNotes.val(attributes["Aditional Notes"] || "" );
    addNotes.on('change', updateNotes ).on('blur', updateNotes );
    let m = descriptor.messages || [];
    if( m.length && m[m.length-1][1] == addNotes.val() ) addNotes.val('');
    function updateNotes(){ attributes["Aditional Notes"] = $(this).val(); changed() };
    // div.append( addNotes );
}

var changed =  function(){ console.log( 'changed', Date.now())};


var myAlert = function( title, body, btn, callback, btn2, callback2, btn3, callback3 )
{
	$('.modal-title').html(title);
    var modal = window.$("#myModal");
	if( typeof(body) == 'string' ) $('.modal-body').html(body);
	else $('.modal-body').html('').append(body);
	modal.modal({
		backdrop: 'static',
		keyboard: false,
	})
	modal.find(".myclose").css({position:'absolute',right:px(10),top:px(0)}).hide();
	// modal.find("#modal-close2").hide();
	modal.find(".btn").hide();
    modal.find('.btn-primary').removeClass('btn-primary');
    modal.find('.btn-secondary').removeClass('btn-secondary');
    modal.find('.btn-danger').removeClass('btn-danger');

    function setButton( id, label, callback ) {
        var bid = '#modal-close'+(id||'');
        var but = modal.find(bid);
        if (!label) label = '';
        var isDanger = label.match(/^\*/);
        var isPrimary = label.match(/^\^/);
        if( isPrimary ) but.addClass('btn-primary')
        else if( isDanger ) but.addClass('btn-danger')
        else but.addClass('btn-secondary');
        label = label.replace(/^[\^\*]/, '');
        but.html(label);
        if( label ) but.show();
        else but.hide();
        but.off('click');
       	if( callback ) but.on('click', callback );
    }
	if( !btn ) btn = 'Ok';
    setButton( '', btn, callback );
    setButton( 2, btn2, callback2 );
    setButton( 3, btn3, callback3 );
}

var myAlertClose = function(callback) {
	if (callback) {
		$('#myModal').on('hidden.bs.modal', function (ev) {
			$('#myModal').off('hidden.bs.modal');
			callback(ev);
		});
	}
	setTimeout(function () {
		$('#myModal').modal('hide');
	}, 10);
}


function saveClipboard( txt )
{
	var input = $('<textarea>').val(txt).css({position:'absolute',top:px(-10000),left:px(-100000)});
	$(document.body).append(input);
	input.select();
	// input.setSelectionRange(0, 99999999);
	document.execCommand("copy");
	setTimeout( function(){
		input.remove();
	}, 100 );
}


function exportData(nocheck)
{
    var ret = {};
    var check = nocheck || declined ? false : true;
    var reasons = [];
    var rchecks = $('.reason');
    for( var i = 0 ; i < rchecks.length ; i++ )
        reasons.push(rchecks[i].id);
    var reasonToAbort = false;
    // tagData.endTimestamp = new Date().getTime();
    // tagData.endUTCTime = new Date().toUTCString();
    // tagData.elapsedTime = tagData.endTimestamp-tagData.startTimestamp;

    // reasons.forEach(function(r)
    // {
    //     if( !$('#'+r).prop('checked') )
    //     {
    //         delete tagData[$('#'+r).attr('fieldname')];
    //         return;
    //     }
    //     tagData[$('#'+r).attr('fieldname')] = true;
    //     reasonToAbort = true;
    // });
    //
    if( declined )
    {
        if( declineReason == '' ) // dont require a reason for now
        {
            frm.myAlert('Decline Task', 'Please inform the reason for declining the task.<br><textarea id="decline_reason" placeholder="enter decline reason" class="export-reason form-control mb-2"></textarea>', 'Ok', function(){
                // alert( declineReason )
                setTimeout( submitAnnotations, 100 )
                // submitAnnotations();
            }, 'Cancel', () => { declined = false;} );
            $('#modal-close').attr('disabled',true);
            function declineCk() {
                declineReason = $('#decline_reason').val().trim();
                console.log( 'declineCk', declineReason );
                $('#modal-close').attr('disabled', declineReason.length < 5 );
            }
            $('#decline_reason').on('change', declineCk ).on('keyup', declineCk );
            return null;
        }
        ret.taskDeclined = true;
        ret.declineReason = declineReason;
        check = false;
    }

    if( descriptor.reviewMode )
	{
		if( !$('#reviewer_rate').val() && check )
		{
			myAlert('Submit Error', 'Please assign the quality of the annotations' );
			return null;
		}
		if( $('#reviewer_rate').val() == 'Adjust' && !$('#reviewer_notes').val().trim() && check )
		{
			myAlert('Submit Error', 'Please add a note to the annotator with your requests' );
			return null;
		}
		ret.review = {rate:$('#reviewer_rate').val(),note:$('#reviewer_notes').val().trim()}
        $('#annotator_notes').val(ret.review.note)
        tagData.mediaAttributes["Aditional Notes"] = ret.review.note
	}
   	if ($('#annotator_notes').val().trim() > '') {
		if (!ret.attributes) ret.attributes = {};
		ret.attributes["Aditional Notes"] = $('#annotator_notes').val().trim();
	}

    if( tagData.attributes )
	{
		for( var i = 0 ; i < tagData.attributes.length ; i++ )
		{
			var a = tagData.attributes[i];
			if( !bool(a.optional) && !tagData.mediaAttributes[a.label] && check )
			{
				myAlert('Submit Error', 'Media attribute "'+ a.label + '" not set. Choose one.');
				$('#t_right').scrollTop( 100000 );
				return null;
			}
		}
	}

    var ranges = [];
    for( var k in wavesurfer.regions.list )
    {
        var r = wavesurfer.regions.list[k];
        if( !r.data.track ) continue;
        var [name,category] = r.data.track.split(txtSeparator);
        var robj = {
            id: k,
            start: r.start,
            end: r.end,
            tag: r.data.tag,
            category: category,
            track: r.data.track,
            text: r.data.text,
            confidence: r.data.confidence,
        }
        ranges.push(robj);
    }
    var sfunc = function (a, b) {
        if (a.category == b.category) {
            if (a.start == b.start) return a.end > b.end ? 1 : -1;
            return a.start > b.start ? 1 : -1;
        }
        else return a.category > b.category ? 1 : -1;
    };
    ranges.sort( sfunc );
    console.log( 'ranges', ranges );
    if( !tagData.streams ) tagData.streams = {};
    tagData.streams[currentMode.name] = [];
    for( var r of ranges )
    {
        var robj = {start:r.start,end:r.end, confidence:r.confidence || 1};
        if( r.text ) robj.text = r.text;
        if( r.tag ) robj.tag = r.tag;
        tagData.streams[r.track].push(robj);
    }

    // if( (!tagData.streams || Object.keys(tagData.streams).length == 0) && !reasonToAbort && check )
    // {
    //     myAlert('Submit Error','You need to add anotations before submiting');
    //     return null;
    // }

    if( !reasonToAbort && check )
    {
        for( var m of totalModes ) {
            // alert( m.name + ', ' + m.optional )
            if( m.optional ) continue;
            if( !tagData.streams || !tagData.streams[m.name] || !tagData.streams[m.name].length ) {
                let id = m.id;
                myAlert('Submit Error','No <b>' + m.name + '</b> annotations added. Please add annotations before submitting.', 'Ok', function(){
                    modeSelDrop.setValue(id);
                });
                return null;
            }
        }
    }

    ['videoSource', 'audioSource', 'DRMURL', 'DRMServerURL', 'streams', 'mediaAttributes'].forEach( a => {
        if( tagData[a] ) ret[a] = clone(tagData[a]);
    })
   	ret.jobStart = descriptor.jobStart;
	ret.sessionTime = (getsec()-descriptor.sessionStart);
	ret.elapsedTime = descriptor.elapsedTime + ret.sessionTime;
    ret.tsSeconds = true;
	ret.updateTime = getsec();
    ret.metadata = descriptor.metadata;

    return ret;
}


function setHierarchy()
{
    var cid = 1000;
    $('.hierarchy').html('<div class="dropdown hierarchy-select" id="hierarchy-classification"><button type="button" class="btn btn-secondary dropdown-toggle" id="example-one-button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button><div class="dropdown-menu" aria-labelledby="example-one-button"><div class="hs-searchbox"><input type="text" class="form-control" autocomplete="off"></div><div class="hs-menu-inner"></div></div><input class="d-none" name="example_one" readonly="readonly" aria-hidden="true" type="text"/></div>');
    var clf = $('#hierarchy-classification');
    clf.hierarchySelect({
        width: '100%',
        resetSearchOnSelection: true,
        onChange: change,
        // onHide: hidden,
        // onShow: shown,
    });
	clf.find('button').on('click',function(){
		clf.find('.active').removeClass('active');
	})
    var hinst = clf.prop('instance');
	// clf.find('button').html(descriptor.buttonLabel);
	function setAddLabel()
	{
		clf.find('button').html('Add Track');
	}
	setAddLabel();
    function change( id )
    {
        // clf.find('button').html('Add Other Skills');
        // clf.find('button').html('Close');
        // addTag(id);
        // hinst.noToggle();
        // setTimeout( function(){ hinst.noToggle = false}, 1 )
        // hinst.dropDown();
        // setTimeout( function(){hinst.dropDown()}, 1 );
		window.trackObj.setTrack( id );
        console.log( 'change', id );
		setAddLabel();
    }
    function hidden(inst){
        console.log( 'hidden' );
        // inst.$button.html(descriptor.buttonLabelExtra)
        // hinst.$searchbox.val('').trigger('propertychange');
        // $('#tags').show();
    }
    function shown(inst){
        console.log( 'shown', inst );
        // inst.$button.html('Close')
        // $('#tags').hide();
    }
    var opts = clf.find('.hs-menu-inner');
    function addOpt( path, leaf )
    {
		// console.log( 'addOpt', path.join('/'), leaf )
        var tid = path.join(' / ');
        // idsFromString[tid] = id;
        // classificationIds[tid] = {path:path, level:level, text:text};
        // // var mydisabled = level == 1 || text == '-';
        // var mydisabled = text == '-';
        // // var oclass = 'dropdown-item tag-level'+level+ ' tag-parent-'+parent;
        // // if( mydisabled ) oclass += ' mydisabled';
        // // var otxt = '<a class="'+oclass+'" id="hid'+id+'" "data-value"="'+tid+'" "data-level"="'+level+'" href="#"></a>';
        // // console.log( otxt );
        // // console.log( 'addOpt', text, level, path, mydisabled, id, parent );
		//
		var text = path.join('/');
		var level = path.length;
        var opt = $('<a class="dropdown-item" href="#">');
        opt.html(text).attr({
            'data-value':tid,
            'data-level':path.length,
        });
		if( !leaf ) opt.addClass('disabled').addClass('node');
        opt.prop('id', 'hid'+tid )
        opt.addClass('tag-level'+level);
        opt.addClass('tag-hierarchy');
        // if( !leaf ) opt.addClass('mydisabled');
        opts.append(opt);
		opt.css({display:'block'})
    }
    function tree( n, path )
    {
        console.log( 'tree', n, path );
		if( isobj( n ) )
		{
			addOpt( path, 0 );
			for( var k in n )
			{
				path.push( k );
				tree( n[k], path )
				path.pop();
			}
		}
		else if( isarray( n ) )
		{
			addOpt( path, 0 );
			for( var i of n )
			{
				path.push( i );
				addOpt( path, 1 );
				path.pop();
			}
		}
		else if( isstring( n ) )
		{
			path.push( n );
			addOpt( path, 1 );
			path.pop();
		}
        // var level = path.length+1;
        // var keys = Object.keys(n);
        // keys.sort();
        // for( var i = 0 ; i < keys.length ; i++ )
        // {
        //     var s = keys[i];
        //     // console.log( 's', s )
        //     var isleaf = ('_value_' in n[s]);
        //     if( isleaf )
        //     {
        //         ftext = n[s]._value_.text;
        //         if( n[s]._value_.alias && n[s]._value_.alias.length > 0 )
        //             ftext += '<span class="alias">'+n[s]._value_.alias+'</span>';
        //         fpath = clone(n[s]._value_.path);
        //         addOpt( ftext, level, fpath, cid++, parent );
        //     }
        //     else {
        //         text = s;
        //         if( text != '-' ) text = beautify(text);
        //         npath = clone(path);
        //         npath.push(s);
        //         var nodeId = cid++;
        //         addOpt( text, level, npath, nodeId, parent );
        //         tree( n[s], npath, nodeId );
        //     }
        // }
    }
    opts.html('');
    console.log( 'treeStart' );
	// console.log( 'hierarchy', hierarchy )
    tree( descriptor.hierarchy, [] );
    console.log( 'treeEnd' );
    $('.dropdown-item').hide();
	$('.tag-hierarchy').show();
}


function modal(title, body, btnTxt, callback) {
    if (!btnTxt) btnTxt = 'Ok';
    return myAlert(title, body, btnTxt, callback);

}

function modalWait(callback) {
    $('#myModal').on('hidden.bs.modal', function (ev) {
        $('#myModal').off('hidden.bs.modal');
        callback(ev);
    });
}


$('.main').hide();

var totalModes = 0;
window.totalModes = totalModes;

function init()
{
    transcriptionMode = descriptor.transcriptionMode ? true : false;

	$('crowd-form').hide();
	if( descriptor.DRMData && !descriptor.DRMData.init )
	{
		descriptor.DRMData.init = function(){
			init();
		}
		return;
	}
	if( transcriptionMode )$('video').addClass('video-transcript');

    totalModes = [];
    if( transcriptionMode ) totalModes.push({
        type:'transcription',
        name: 'Transcription',
        mode: 'Transcription',
        optional: false,
    })
    if( descriptor.segmentation && descriptor.segmentation.length )
        for( var s of descriptor.segmentation )
        {
            s.type = 'segmentation';
            s.mode = s.name;
            totalModes.push(s);
        }

    totalModes.forEach( (m, idx) => m.id = idx )
	$('#videotrackanotate').html('');

	if( descriptor.hierarchy )
	{
		setHierarchy();
	}
	if( descriptor.streamsUrl )
	{
		var url = descriptor.streamsUrl;
		delete descriptor.streamsUrl;
		$.get(url,(r) => {
			descriptor.streams = r;
			console.log( 'SSSSSSSSSSSSS', r )
			init();
		})
		return;
	}

    var tr = new tracks( $('#videotrackanotate'), $('#video'), null, tagData, $('#reportpanel') );
	window.trackObj = tr;

	if( !tagData.attributes ) $('#video-attr').hide();
    if( !tagData.mediaAttributes ) tagData.mediaAttributes = {};
    listAttributes( $('#video-attr'), tagData.attributes, tagData.mediaAttributes, 'Media Attributes' )
    $('crowd-form').on('submit',function() {
        var annotations = exportData();
        if( document.location.href.indexOf('localhost') >= 0 && annotations ) saveClipboard( JSON.stringify(annotations.streams || {}) )
        if( annotations )
        {
            $('crowd-form').show();
            document.getElementById('annotations').value = JSON.stringify(annotations);
        }
        else
        return false;
    });
	// $('#submitBox').show();
   	var form = document.querySelector('crowd-form');
    setButtons(descriptor);
    showSave('Session started', descriptor.sessionStart*1000 )

    $('#submitButton').on('click', function () {
        declined = false;
        if (form) form.submit();
        else submitAnnotations();
    });
    // if (descriptor.canDecline !== false) {
    //     $('#submitButton').removeClass('mt-2').addClass('mr-2');
    //     var decline = $('<button type="submit" class="btn btn-primary btn-danger mr-2">').html('<img class="mr-2" src="imgs/decline.svg" />Decline');//modify Decline Task  as  Decline  & add svg- mani
    //     $('#submitButton').after(decline);
    //     decline.on('click', function () {
    //         declined = true;
    //         if (form) form.submit();
    //         else submitAnnotations();
    //     });
    // }
}

function exists( o )
{
	if( !o ) return false;
	if( !isobj(o) && !isarray(o)) return false;
	return Object.keys(o).length > 0;
}


function showHide( o, cond )
{
	if( cond ) o.show();
	else o.hide();
}

var chatNotificationRead = false;
function displayNotes() {
    // return;
	$('#messages').remove();
	if (descriptor.reviewMode) {
		$('#reviewer_notes').hide();
		$('#submitReviewer').show();
	}
	else {
		// $('#messages').hide();
		$('#annotator_notes').hide();
		$('#submitReviewer').hide();
	}
	$('#chatbox').removeClass('unselectable').css({position:'relative'});
	$('#chat_notification').hide();
	$('#chatbox').off('click').on('click', chatPopup );
	if( !chatNotificationRead )
		if( $('#reviewer_notes').val().trim() || $('#annotator_notes').val().trim() || (descriptor.messages && descriptor.messages.length)) $('#chat_notification').css({marginTop:3}).show();
;
}

function chatPopup() {
	let content = '<div id="messages" class="file-messages"></div>';
		if( descriptor.reviewMode ) {
			content += '<textarea id="chat_reviewer_notes" class="inote-text mt-2" placeholder="Reviewer Notes"></textarea>';
		}
		else {
			content += '<textarea id="chat_annotator_notes" class="inote-text mt-2" placeholder="Annotator Notes"></textarea>';
		}
		frm.myAlert( 'Messages', content, 'Ok' );
		displayMessages();
	if( blockEdit ) {
		$('.modal-body').find('textarea').attr('disabled', true);
	}
	setTimeout( function(){
		$('.modal-body').scrollTop( 100000 )
		if( !blockEdit ) {
			if( descriptor.reviewMode ) {
				$('#chat_reviewer_notes')[0].focus();
			}
			else {
				$('#chat_annotator_notes')[0].focus();
			}
		}
        else {
            $('#chat_annotator_notes').val('')
        } 
	}, 500 )

	// copy notes to original text area for compatibility
	$('#chat_reviewer_notes').on('change', function(){
		$('#reviewer_notes').val($(this).val());
		changed();
	} ).val($('#reviewer_notes').val())
	$('#chat_annotator_notes').on('change', function(){
		$('#annotator_notes').val($(this).val());
		descriptor.mediaAttributes["Aditional Notes"] = $(this).val(); 
		changed()
	} ).val($('#annotator_notes').val())
    if( blockEdit ) $('#chat_annotator_notes').val('')


	chatNotificationRead = true;
	$('#chat_notification').hide();
}


function displayMessages()
{
	if( !descriptor.messages ) return;
	$('#messages').show().html('');
	var role = ['Annotator','QC'];

	var showMoreLess = $('<DIV>').addClass('message-show');
	$('#messages').append(showMoreLess);
	var nshow = 2;
	var nmess = descriptor.messages.length;
	function showMore()
	{

	}
	function show()
	{
		var hidden = 0;
		for( var i = 0 ; i < nmess-nshow ; i++ )
		{
			$('.message-idx-'+i).hide();
			hidden++;
		}
		for( ; i < nmess ; i++ )
			$('.message-idx-'+i).show();
		if( hidden )
		{
			showMoreLess.text('Show more messages').off('click').on('click', function(){
				nshow += 3;
				show();
			});
		}
		else if( nmess > 2 )
		{
			showMoreLess.text('Show less messages').off('click').on('click', function(){
				nshow = 1;
				show();
			});
		}
	}
	
	descriptor.messages.forEach((m,idx)=>{
		var m = $('<DIV>').addClass('message-'+m[0]).addClass('message-idx-'+idx).html('<i>'+role[m[0]]+'</i><br>' + m[1]);
		$('#messages').append(m);
	});
	// show();
}


function displayMessagesOld()
{
	$('#messages').show().html('');
	var role = ['Annotator','QC'];

	var showMoreLess = $('<DIV>').addClass('message-show');
	$('#messages').append(showMoreLess);
	var nshow = 2;
	var nmess = descriptor.messages.length;
	function showMore()
	{

	}
	function show()
	{
		var hidden = 0;
		for( var i = 0 ; i < nmess-nshow ; i++ )
		{
			$('.message-idx-'+i).hide();
			hidden++;
		}
		for( ; i < nmess ; i++ )
			$('.message-idx-'+i).show();
		if( hidden )
		{
			showMoreLess.text('Show more messages').unbind('click').on('click', function(){
				nshow += 3;
				show();
			});
		}
		else if( nmess > 2 )
		{
			showMoreLess.text('Show less messages').unbind('click').on('click', function(){
				nshow = 1;
				show();
			});
		}
	}

	descriptor.messages.forEach((m,idx)=>{
		var m = $('<DIV>').addClass('message-'+m[0]).addClass('message-idx-'+idx).html('<i>'+role[m[0]]+'</i><br>' + m[1]);
		$('#messages').append(m);
	});
	show();
}


var questionMode = false;
var currentQuestion = 0;

function start(desc) {
    descriptor = tagData = desc;
    window.descriptor = descriptor;
	reviewMode = descriptor.reviewMode ? true : false;

    if( mode == 'template' ) $('#resumeLater').hide();
    $('#reviewer-fields').hide();
    $('#annotator_notes').show();
	if( descriptor.reviewMode )
	{
		$('#reviewer-fields').show();
		$('#annotator_notes').hide();
		if( !descriptor.reviewMayRequestAdjustment ) $('#optadjust').remove();
	}
	if( !exists( descriptor.messages) ) $('#messages').hide();
	else displayMessages();
	$('#reviewer_rate').on('change', changed );
	$('#reviewer_notes').on('change', changed );
	$('#annotator_notes').on('change', changed );
	var now = getsec();
	if( !descriptor.elapsedTime )
	{
		descriptor.elapsedTime = 0;
		if( !descriptor.jobStart ) descriptor.jobStart = now;
	}
    else if( !descriptor.tsSeconds ) descriptor.elapsedTime /= 1000;
	descriptor.sessionStart = now;

    if( mode != 'template' )
    {
        $(document.body).css({overflow:'hidden'});
    }

    if (!descriptor.questionnaire || !descriptor.questionnaire.length) init();
    else {
        questionMode = true;
        function submitQuestions() {
            var annotations = { videoData: descriptor.videoData, annotations: clone(descriptor.questionnaireAnnotations) };
            if (document.location.href.indexOf('localhost') >= 0) saveClipboard(JSON.stringify(annotations.annotations))
            if (annotations) {
                document.getElementById('annotations').value = JSON.stringify(annotations);
                $('crowd-form').show();
                $('crowd-form')[0].onsubmit = null;
                $('crowd-form')[0].submit();
            }
            else
                return false;
        }

        function question(q) {
            function save(callback) {
                // if( 0 && !questionData.answer )
                // {
                // 	modal( 'Answer Required', 'Please answer the question' );
                // 	return false;
                // }
                questionData.streams = tr.saveTracks();
                var nev = 0;
                questionData.streams.forEach(e => {
                    nev += e.ranges.length;
                });
                if (questionData.false && !questionData.userAnswer) {
                    return modal('Answer Required', 'Please write the correct answer for the question.', 'Ok', function () {
                        modalWait(function () {
                            $('#questionUserAnswer').focus();
                        })
                    })
                }
                if (!nev) {
                    if (questionData.streams.length) return modal('Record Evidence Position', "You must record the evidence position in the video.")
                    modal('Evidence Required', 'Please annotate evidences about your answer.');
                    return;
                }
                console.log('streams', questionData.streams);
                if (!questionData.false) delete questionData.userAnswer;
                descriptor.questionnaireAnnotations[q] = questionData;
                // if( nev && !questionData.false )
                // {
                // 	return modal( 'Discard Evidence', 'You selected the answer as <b>True</b>. Discard current annotated evidences?', 'Discard Evidences', function(){
                // 		modalWait( function(){
                // 			questionData.streams = [];
                // 			callback();
                // 		} );
                // 	} );
                // }
                $('#questionUserAnswer').unbind('change')
                callback();
                return true;
            }
            $('#prevnextBox').show();
            // if( q == descriptor.questionnaire.length ) return submitQuestions();
            var qlab = descriptor.questionnaire[q].question;
            currentQuestion = q;

            if (!descriptor.questionnaireAnnotations) descriptor.questionnaireAnnotations = {};
            if (!descriptor.questionnaireSettings) descriptor.questionnaireSettings = {};
            if (!descriptor.questionnaireAnnotations[currentQuestion]) descriptor.questionnaireAnnotations[currentQuestion] = {};
            $('#questionTitle').html('Q.: ' + descriptor.questionnaire[currentQuestion].question);
            $('#questionInstructions').html(descriptor.questionnaireInstructions || '');
            $('crowd-form').hide();
            $('#videotrackanotate').html('');
            $('#reportpanel').html('');
            var tr = new tracks($('#videotrackanotate'), $('#video'), null, tagData, $('#reportpanel'));

            var questionData = descriptor.questionnaireAnnotations[currentQuestion];
            questionData.question = qlab;
            questionData.answer = descriptor.questionnaire[currentQuestion].answer
            // questionData.userAnswer = descriptor.questionnaire[currentQuestion].userAnswer
            // $('#questionAnswer').val(questionData.answer).unbind('change').on('change',function(){ questionData.answer = $(this).val().trim()});
            $('#questionAnswer').html('A.: ' + questionData.answer);
            showHide($('#questionUserAnswer'), questionData.false);
            checkBox($('#questionFalse'), 'False', questionData.false, function (v) {
                questionData.false = v;
                showHide($('#questionUserAnswer'), v);
            });
            $('#questionUserAnswer').val(questionData.userAnswer).unbind('change').on('change', function () {
                questionData.userAnswer = $(this).val();
                console.error('userAnswer', questionData.userAnswer)
            })

            setTimeout(function () {
                console.log('questionData', questionData)
                tr.loadTracks(questionData.streams);
            }, 100);

            if (!tagData.attributes) $('#video-attr').hide();
            if (!tagData.mediaAttributes) tagData.mediaAttributes = {};
            listAttributes($('#video-attr'), tagData.attributes, tagData.mediaAttributes, 'Media Attributes')
            // function submitAnnotations(ev) {
            //     save(function () {
            //         submitQuestions()
            //     });
            // };
            // if (q < descriptor.questionnaire.length - 1) $('#submitBox').hide();
            // else $('#submitBox').show();
            $('.trackaddbutton').html(descriptor.questionnaire[currentQuestion].button);
            $('.prevnext_number').html('<span>' + (q + 1) + ' of ' + descriptor.questionnaire.length + '</span>')
            $('#buttonPrev').prop('disabled', q == 0).unbind('click').on('click', function () {
                save(function () {
                    question(currentQuestion - 1)
                })
            });
            $('#buttonNext').prop('disabled', q == descriptor.questionnaire.length - 1).unbind('click').on('click', function () {
                save(function () {
                    question(currentQuestion + 1)
                })
            });
            $('#submitButton').off('click').on('click', submitAnnotations);
        }
        $('#video-attr').hide();
        question(0);
    }
}

// EXPORTEND
var declined = false;
var claimed = false;
var released = false;
var blockEdit = false;

function fixButtons(descriptor) {
	if( !descriptor ) return;
	$('.task-button').hide();
	$('.claim-button').html('Claim Task as '+descriptor.task_role)
    $('#reviewer_rate_div').hide()
    if( descriptor.task_role ) 
	if( descriptor.blockEdit ) {
		if( descriptor.task_can_claim ) {
			if( descriptor.task_auto_claim ) {
				setTimeout( function(){
					$('.claim-button')[0].click();
				}, 1 );
			}
			else {
				$('.claim-button').show();
			}
		}
		$('#resumeLater').hide();
	}
	else {
        if( descriptor.task_role == 'Reviewer') {
            $('#reviewer_rate_div').show()
        }
		$('#resumeLater').show();
		$('.claim-button').hide();
		$('.submit-button').show();
		$('.autolabel-button').show();
		if( descriptor.task_can_decline ) $('.decline-button').show();
		if( descriptor.task_can_release ) {
			$('.release-button').show();
		}
	}
	reviewMode = descriptor.reviewMode
	if( descriptor.reviewMode )
	{
		$('#reviewer-fields').show();
		$('#annotator_notes').hide();
		if( !descriptor.reviewMayRequestAdjustment ) $('#optadjust').remove();
	}
	blockEdit = descriptor.blockEdit;
	displayNotes();
	// ckSelectDisable();
	// $('#right').find('select').attr('disabled', blockEdit)

}


function setButtons(descriptor,form) {
	$('#submitButton').removeClass('mt-2').addClass('mr-2').addClass('submit-button').addClass('task-button');
	var claimBtn = $('<button type="submit" class="btn btn-primary btn-primary mr-2 task-button claim-button">').html('Claim Task');
	$('#submitButton').before(claimBtn);
	claimBtn.on('click', function () {
		claimTask(descriptor);
	});
	var declineBtn = $('<button type="submit" class="btn  btn-danger mr-2 task-button decline-button">').html('<i class=" mr-2 fa fa-ban" aria-hidden="true"></i>Decline  ').hide();//modify Decline Task  as  Decline - mani
	$('#submitButton').after(declineBtn);
	declineBtn.on('click', function () {
		declined = claimed = released = false;
		declined = true;
		if (form) form.submit();
		else submitAnnotations();
	});
	var releaseBtn = $('<button type="submit" class="btn btn-primary btn-warning mr-2 task-button release-button">').html('<i class=" mr-2 fa fa-unlock" aria-hidden="true"></i>Release');  //modify Release Task  as Remove - mani
	declineBtn.after(releaseBtn);
	releaseBtn.on('click', function () {
		releaseTask(descriptor);
	});
	descriptor.fixButtons = fixButtons;
	fixButtons(descriptor);
}


var claimTask = function(d) {
	descriptor.claimCallback(d);
}

var releaseTask = function(d) {
	descriptor.releaseCallback(d);
}


var submitAnnotations = async function()
{
	var annotations = exportData();
	if( annotations )
	{
        let isDecline = declined && declineReason;
		if( !isDecline && !await frm.myConfirm( 'Confirm Submit', "Do you really want to submit your annotations?", null, "Yes, submit annotations", "No")) 
			return;

		if( descriptor.reviewMode ) annotations.review.reviewerId = window.GlobalVars.userId || window.GlobalVars.userWoekerId;
		clearTimeout( changeTid );
		descriptor.submit(annotations);
		// document.getElementById('annotations').value = JSON.stringify(annotations);
	}
	else
	return false;
};

var updateFlag = false;
function updating(){
	return updateFlag;
}

function showSave(s, ts)
{
	// descriptor.version = s;
	if( ts ) s += ' - ' + new Date(ts).toLocaleString()
	$('#version').remove();
    $('#submit').hide();
	$('#t_right').prepend(
		$('<span>')
		.addClass('version')
		.prop('id','version')
		.html(s)
	);
}


var changeTid = null;
changed = function()
{
    if( descriptor.blockEdit ) return;
    console.log( 'changed')
	clearTimeout( changeTid );
    updateFlag = true;
    window.onbeforeunload = function(ev){
		ev.preventDefault();
		return ev.returnValue = "Are you sure you want to exit?";
	}
	changeTid = setTimeout( function(){
        var annotations = exportData(1);
		if( descriptor.reviewMode ) annotations.review.reviewerId = window.GlobalVars.userId || window.GlobalVars.userWoekerId;
		descriptor.update(annotations, res => {
            window.onbeforeunload = null;
            updateFlag = false;
            showSave('Saved', Date.now() )
        });
	}, 500 );
	// return;
}

function checkInstructions(descriptor) {
    if(descriptor.blockEdit) return;

    const engine = new Liquid();

    const data = (descriptor.pdf && descriptor.pdf.metadata) || descriptor.metadata

    // Render a template using Liquid
    let itext = (descriptor.globalTaskInstructions && descriptor.globalTaskInstructions.text) || '';
    if( itext ) {
        engine
            .parseAndRender(itext.replace(/\n/g, '<br>'), data)
            .then(result => {
                if (descriptor.globalTaskInstructions.showModal && descriptor.globalTaskInstructions.text) {
                    frm.myAlert('Instructions', result, 'Ok');
                }
    
                if(descriptor.globalTaskInstructions.text){
                    if($('#right').find('.instruct').length > 0){
                        $('#right').find('.instruct').remove();
                    }
    
                    let instructionsBox = `
                    <div class="instruct">
                        <div class="panel-title">Instructions</div>
                        <p>${result || 'No Instrctions set'}</p>
                    </div>`
                    
                    $('#right').prepend(instructionsBox)
                }
            })
            .catch(error => {
                console.error('Error rendering template:', error);
            });
    }
}
checkInstructions(descriptor);

myAlert = frm.myAlert;
myAlertClose = frm.myAlertClose;


export default {start,updating}